document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('img[width="1"]').forEach(img => img.setAttribute('alt', ''));


    function renderResponsive() {
        const navBtn = document.querySelector('[data-id="#nt_menu_canvas"]');
        if(!navBtn) return;

        if(window.innerWidth > 1023) {
            const newLinkSpan = document.createElement("span");
            for (const attr of navBtn.attributes) {
                newLinkSpan.setAttribute(attr.name, attr.value);
            }
            newLinkSpan.innerHTML = navBtn.innerHTML;
            navBtn.replaceWith(newLinkSpan);
        }
    }

    // Run on load
    renderResponsive();

    function fixMenuEmptyLink() {
        const items = document.querySelectorAll(".menu-item");
        const menuItems = document.querySelectorAll(".menu-item .lazy_menu.lazyload");

        menuItems.forEach((item, index) => {
            const observer = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                if (mutation.attributeName === "class" && item.classList.contains("lazyloaded")) {

                    const hiddenText = item.querySelector(".banner_hzoom.nt_promotion a.pa .visually-hidden.hidden-text");
                    const title = items[index].querySelector("a.lh__1");
                    if(title) {
                        hiddenText.innerText = title.innerText;
                    }

                    observer.disconnect();
                }
                });
            });

            observer.observe(item, { attributes: true });
        });
    }

    fixMenuEmptyLink();

    function fixBuildCustomKitchenPackageForm() {
        if(!window.location.pathname.endsWith("/build-a-custom-kitchen-package")) return;

        function fixEnterKey(form) {
            form.addEventListener('keydown', (event) => {
                if (event.key !== 'Enter') return;

                const target = event.target;
                if (!target) return;

                const tag = target.tagName.toLowerCase();
                const type = (target.getAttribute('type') || '').toLowerCase();

                if (tag === 'textarea' || tag === 'button' || type === 'submit') return;

                // Toggle checkbox with Enter key
                if (type === 'checkbox') {
                    event.preventDefault();
                    event.stopPropagation();
                    target.click();
                    return;
                }

                // Prevent form submit for other inputs
                event.preventDefault();
                event.stopPropagation();
            }, { capture: true });
        }

        const observer = new MutationObserver((mutation, obs) => {
            const form = document.querySelector("#formGeneratorForm");
            if(form) {
                setTimeout(() => {
                    form.querySelectorAll("div, label").forEach(item => {
                        item.removeAttribute("tabindex");
                        item.removeAttribute("aria-describedby");
                        item.removeAttribute("aria-label");
                    });

                    const fieldset = form.querySelector(".checkbox-multi");
                    if(fieldset) {
                        
                        fieldset.querySelectorAll("input").forEach(item => {
                            item.style.display = 'block';
                            item.classList.add('visually-hidden');
                        });

                        const firstLabel = fieldset.querySelector(":scope > label");

                        if(firstLabel) {
                            const newLegend = document.createElement("legend");
                            newLegend.className = firstLabel.className;
                            newLegend.innerText = firstLabel.innerText;
                            firstLabel.replaceWith(newLegend);
                        }

                        fieldset.querySelectorAll(".checkbox-list > label").forEach(item => {
                            const span = document.createElement("span");
                            span.className = item.className;

                            while (item.firstChild) {
                                span.appendChild(item.firstChild);
                            }

                            item.replaceWith(span);
                        });
                        
                        
                        const newFieldset = document.createElement("fieldset");
                        newFieldset.className = fieldset.className;

                        while(fieldset.firstChild) {
                            newFieldset.appendChild(fieldset.firstChild);
                        }

                        fieldset.replaceWith(newFieldset);
                    }

                    fixEnterKey(form);

                     // Apply autocomplete
                    const autocompleteMap = {
                        'name': 'name',
                        'email address': 'email',
                        'phone number': 'tel'
                    };

                    form.querySelectorAll('input, textarea, select').forEach(field => {
                        const id = field.id;
                        let labelText = '';
                        if (id) {
                            const label = form.querySelector(`label[for="${id}"]`);
                            if (label) labelText = label.textContent || '';
                        }
                        if (!labelText && field.hasAttribute('aria-label')) {
                            labelText = field.getAttribute('aria-label') || '';
                        }
                        const normalized = labelText.replace('*', '').trim().toLowerCase();
                        if (autocompleteMap[normalized]) {
                            field.setAttribute('autocomplete', autocompleteMap[normalized]);
                        }
                    });

                    const cleanAlerts = () => {
                        form.querySelectorAll('.alert_message .alert-danger p.alert-danger').forEach(msg => {
                            msg.removeAttribute('tabindex');
                            msg.removeAttribute('aria-label');
                        });
                    };

                    cleanAlerts();

                    const alertContainer = form.querySelector('.alert_message');
                    if (alertContainer) {
                        const alertObserver = new MutationObserver(cleanAlerts);
                        alertObserver.observe(alertContainer, {
                            childList: true,
                            subtree: true
                        });
                    }

                    form.addEventListener('submit', () => {
                        setTimeout(cleanAlerts, 50);
                    });


                }, 2000);
                 obs.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    fixBuildCustomKitchenPackageForm();

    function onAllChildrenReady(parentSelector, childSelector, callback) {
        const parents = document.querySelectorAll(parentSelector);
        if (!parents.length) return;

        const readyParents = new Set();
        const allParentsMap = new Map();

        parents.forEach(parent => {
            allParentsMap.set(parent, false);

            // Check if the content already exists.
            if (parent.querySelector(childSelector)) {
                readyParents.add(parent);
                allParentsMap.set(parent, true);
            } else {
                const observer = new MutationObserver(() => {
                    if (parent.querySelector(childSelector)) {
                        readyParents.add(parent);
                        allParentsMap.set(parent, true);
                        observer.disconnect();

                        if (readyParents.size === parents.length) {
                            callback(Array.from(allParentsMap.keys()));
                        }
                    }
                });
                observer.observe(parent, { childList: true, subtree: true });
            }
        });

        if (readyParents.size === parents.length) {
            callback(Array.from(allParentsMap.keys()));
        }
    }

    function fixModalProduct(element, prevSibling) {
        const id = element.getAttribute("data-opennt");
        const container = document.querySelector(id);
        if (!container) {
            console.warn('[Accessibility] Modal container not found for selector:', id);
            return;
        }

        let lazyImg = container.querySelector(".product-image.lazyload, .product-image.lazyloaded");
        if (!lazyImg) {
            console.warn('[Accessibility] Modal image not found for selector:', id);
            return;
        }

        const productTitle = container.querySelector('.product-title a');
        productTitle.id = 'popup-'+id;

        setTimeout(() => {
            const dialog = document.querySelector('.mfp-wrap');
            const modalContainer = container.querySelector('.pin__popup .product');

            if (dialog) {
                modalContainer.removeAttribute('aria-labelledby');
                modalContainer.removeAttribute('role');
                dialog.setAttribute('aria-labelledby', productTitle.id);
                dialog.setAttribute('role', 'dialog');
            } else {
                modalContainer.setAttribute('aria-labelledby', productTitle.id);
                modalContainer.setAttribute('role', 'dialog');
                modalContainer.tabIndex = '-1';
                modalContainer.focus();
                }
        }, 500);

        const onImageReady = () => {
            const hoverButtons = container.querySelector('.hover_button');
            let hideHoverButtonsFn = null;

            container.querySelectorAll('.product-image a').forEach(link => {
                link.setAttribute('aria-describedby', productTitle.id)
            })

            if(hoverButtons) {
                hoverButtons.querySelectorAll('.nt_add_w > a:not([applied]), .nt_add_w > span:not([applied]), .nt_add_cp > a:not([applied]), .nt_add_cp > span:not([applied])').forEach(link => {
                    link.setAttribute('applied', 'true');
                    setTimeout(() => {
                        const text = link.querySelector('.tt_txt');
                        if (!text) return
                        const updateLabel = () => link.setAttribute('aria-label', text.textContent);
                        updateLabel();
                        link.addEventListener('click', () => {
                            setTimeout(() => updateLabel(), 300);
                        });
                        link.addEventListener('keydown', (e) => {
                            if (e.key === 'Enter') setTimeout(() => updateLabel(), 300);
                        });
                    }, 200);
                });
            }

            const rating = container.querySelector('.jdgm-prev-badge__stars');
            if(rating) {
                rating.setAttribute('aria-label', `${rating.getAttribute('data-score')} out of 5 stars`);
                rating.setAttribute('role', 'img');
                rating.removeAttribute('tabindex');
            }

            const price = container.querySelector('.price');
            if(price) {
                price.id = 'price-'+id;
                productTitle.setAttribute('aria-describedby', price.id);
            }

            if (hoverButtons && !hoverButtons.dataset.accessibilityEnhanced) {
                hoverButtons.dataset.accessibilityEnhanced = 'true';
                hoverButtons.style.visibility = 'visible';
                hoverButtons.classList.add('op__0');

                const focusables = hoverButtons.querySelectorAll('a, button, [role="button"]');
                focusables.forEach(control => {
                    control.setAttribute('tabindex', '0');
                    control.setAttribute('role', 'button');
                });

                const showHoverButtons = () => {
                    hoverButtons.classList.add('focus-visible');
                    hoverButtons.classList.remove('op__0');
                    hoverButtons.style.opacity = '1';
                    hoverButtons.style.pointerEvents = 'auto';
                };

                const hideHoverButtons = () => {
                    hoverButtons.classList.remove('focus-visible');
                    hoverButtons.classList.add('op__0');
                    hoverButtons.style.opacity = '0';
                    hoverButtons.style.pointerEvents = 'none';
                };

                hideHoverButtons();

                focusables.forEach(control => {
                    control.addEventListener('focus', showHoverButtons);
                    control.addEventListener('blur', () => {
                        requestAnimationFrame(() => {
                            if (!hoverButtons.contains(document.activeElement)) {
                                hideHoverButtons();
                            }
                        });
                    });
                });

                const hoverTarget = hoverButtons.closest('.product-inner') || hoverButtons.parentElement;
                if (hoverTarget && !hoverTarget.dataset.hoverButtonsBound) {
                    hoverTarget.addEventListener('mouseenter', showHoverButtons);
                    hoverTarget.addEventListener('mouseleave', () => {
                        if (!hoverButtons.contains(document.activeElement)) {
                            hideHoverButtons();
                        }
                    });
                    hoverTarget.dataset.hoverButtonsBound = 'true';
                }

                hoverButtons.__showHoverButtons = showHoverButtons;
                hoverButtons.__hideHoverButtons = hideHoverButtons;
                hideHoverButtonsFn = hideHoverButtons;
            } else if (hoverButtons) {
                hideHoverButtonsFn = hoverButtons.__hideHoverButtons || (() => {
                    hoverButtons.classList.add('op__0');
                    hoverButtons.style.opacity = '0';
                    hoverButtons.style.pointerEvents = 'none';
                    hoverButtons.style.visibility = 'visible';
                    hoverButtons.classList.remove('focus-visible');
                });
                hideHoverButtonsFn();
            }

            // const productImage = container.querySelector('.product-image');
            // if (productImage && !productImage.hasAttribute('tabindex')) {
            //     productImage.setAttribute('tabindex', '0');
            // }

            // const productLink = container.querySelector('.product-image a');
            // if (productLink) {
            //     productLink.setAttribute('tabindex', '-1');
            //     productLink.setAttribute('aria-hidden', 'true');
            // }

            const stars = container.querySelector('.jdgm-prev-badge__stars');
            if (stars) {
                stars.removeAttribute('role');
                stars.removeAttribute('tabindex');
            }

            const pinType = container.closest('.pin__type');
            const desktopPopup = container.querySelector('.pin__popup');

            const checkForModal = () => {
                const mfpWrap = document.querySelector('.mfp-wrap.mfp-ready');

                if (mfpWrap) {
                    trapFocus(mfpWrap, prevSibling, undefined, true);

                    const cleanupModal = () => {
                        hideHoverButtonsFn?.();
                        if (mfpWrap.__trapFocusHandler) {
                            mfpWrap.removeEventListener('keydown', mfpWrap.__trapFocusHandler);
                            delete mfpWrap.__trapFocusHandler;
                            delete mfpWrap.dataset.trapFocusBound;
                        }
                        document.removeEventListener("keydown", handleEsc);
                    };

                    function handleEsc(event) {
                        if (event.key === "Escape" || event.key === "Esc") {
                            cleanupModal();
                            setTimeout(() => {
                                prevSibling?.focus();
                            }, 500);
                        }
                    }
                    document.addEventListener("keydown", handleEsc);
                    const modalCloseButton = mfpWrap.querySelector('.mfp-close');
                    if (modalCloseButton) {
                        modalCloseButton.setAttribute('aria-label', 'Close');
                        modalCloseButton.removeAttribute('title');
                        modalCloseButton.setAttribute('tabindex', '0');
                        modalCloseButton.addEventListener('click', cleanupModal, { once: true });
                        modalCloseButton.addEventListener('keydown', (e) => {
                            if(e.key === 'Enter') {
                                const escEvent = new KeyboardEvent('keydown', {
                                    key: 'Escape',
                                    code: 'Escape',
                                    keyCode: 27, // legacy
                                    which: 27,   // legacy
                                    bubbles: true,
                                    cancelable: true
                                });

                                document.dispatchEvent(escEvent);
                            }
                        })
                    }

                    const modalObserver = new MutationObserver((mutations) => {
                        mutations.forEach((mutation) => {
                            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                                if (mfpWrap.classList.contains('mfp-removing')) {
                                    cleanupModal();
                                    modalObserver.disconnect();
                                    setTimeout(() => {
                                        prevSibling?.focus();
                                    }, 100);
                                }
                            }
                        });
                    });

                    modalObserver.observe(mfpWrap, {
                        attributes: true,
                        attributeFilter: ['class']
                    });
                } else if (pinType) {
                    if (desktopPopup) {
                        desktopPopup.setAttribute('inert', '');
                    }

                    const waitForOpened = () => {
                        if (pinType.classList.contains('pin__opened')) {

                            if (desktopPopup && !desktopPopup.dataset.trapFocusBound) {
                                desktopPopup.removeAttribute('inert');
                                trapFocus(desktopPopup, element, undefined, false);

                                const cleanupDesktopModal = () => {
                                    hideHoverButtonsFn?.();
                                    if (desktopPopup.__trapFocusHandler) {
                                        desktopPopup.removeEventListener('keydown', desktopPopup.__trapFocusHandler);
                                        delete desktopPopup.__trapFocusHandler;
                                        delete desktopPopup.dataset.trapFocusBound;
                                    }
                                    document.removeEventListener("keydown", handleDesktopEsc);
                                    pinTypeObserver.disconnect();
                                    desktopPopup.setAttribute('inert', '');
                                };

                                function handleDesktopEsc(event) {
                                    if (event.key === "Escape" || event.key === "Esc") {
                                        document.body.click();
                                        cleanupDesktopModal();
                                        setTimeout(() => {
                                            prevSibling?.focus();
                                        }, 300);
                                    }
                                }
                                document.addEventListener("keydown", handleDesktopEsc);

                                const pinTypeObserver = new MutationObserver((mutations) => {
                                    mutations.forEach((mutation) => {
                                        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                                            if (!pinType.classList.contains('pin__opened')) {
                                                cleanupDesktopModal();
                                                setTimeout(() => {
                                                    prevSibling?.focus();
                                                }, 100);
                                            }
                                        }
                                    });
                                });

                                pinTypeObserver.observe(pinType, {
                                    attributes: true,
                                    attributeFilter: ['class']
                                });
                            }
                        } else {
                            setTimeout(waitForOpened, 50);
                        }
                    };

                    waitForOpened();
                } else {
                    setTimeout(checkForModal, 50);
                }
            };

            setTimeout(checkForModal, 100);
        };

        if (lazyImg.classList.contains('lazyloaded')) {
            onImageReady();
        } else {
            const observer = new MutationObserver(() => {
                if (lazyImg.classList.contains('lazyloaded')) {
                    onImageReady();
                    observer.disconnect();
                }
            });
            observer.observe(lazyImg, { attributes: true, attributeFilter: ['class'] });
        }
    }

    onAllChildrenReady("[id^='pin_mfp_']", ".product-title a", (parents) => {
        const parentMap = {};
        parents.forEach(p => {
            parentMap[p.id] = p;
        });
        const isModalActive = window.innerWidth < 1367;
        document.querySelectorAll("[data-opennt]").forEach((element) => {
            const targetId = element.getAttribute("data-opennt").substring(1);
            const parent = parentMap[targetId];

            if (parent) {
                const titleModal = parent.querySelector(".product-title a");
                if (titleModal) {
                    const prevSibling = element.previousElementSibling;
                    if(isModalActive) {
                        prevSibling.setAttribute('aria-hidden', 'true');
                    } else {
                        element.setAttribute('aria-hidden', 'true');
                    }


                    const activeElement = isModalActive ? element : prevSibling;
                    if (activeElement) {
                        activeElement.setAttribute("tabindex", "0");
                        activeElement.setAttribute("role", "button");
                        activeElement.setAttribute("aria-label", `Open ${titleModal.textContent.trim()} modal`);

                        // element.addEventListener('click', (e) => {
                        //     e.preventDefault();
                        //     prevSibling.click();
                        // });

                        activeElement.addEventListener('keydown', (e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                activeElement.click();
                            }
                        });

                        // prevSibling.addEventListener('keydown', (e) => {
                        //     if (e.key === 'Enter') {
                        //         e.preventDefault();
                        //         prevSibling.click();
                        //     }
                        // });

                        activeElement.addEventListener('click', () => {
                            fixModalProduct(element, activeElement);
                        });
                    } else {
                        console.warn('[Accessibility] No previous sibling found for data-opennt element', element);
                    }
                }

                const h3Title = parent.querySelector(".product-title");
                if (h3Title && h3Title.tagName === 'H3') {
                    const div = document.createElement('div');
                    div.className = h3Title.className + ' h3';
                    div.innerHTML = h3Title.innerHTML;
                    h3Title.replaceWith(div);
                }
            }
        });
    });

        function trapFocus(container, btnOpenModal, focusableElements, focusFirstElement = true) {
            let focusables = [];
            if(focusableElements) {
                focusables = focusableElements;
            } else {
                focusables = getFocusableElements(container);
            }
            if (focusables.length === 0) return;
            
            // Focus first element
            if(focusFirstElement) {
                focusables[0].focus();
            }

            container.addEventListener('keydown', (e) => {
                if (e.key !== 'Tab') return;

                const first = focusables[0];
                const last = focusables[focusables.length - 1];

                if (e.shiftKey) {
                    if (document.activeElement === first) {
                        e.preventDefault();
                        last.focus();
                    }
                } else {
                    if (document.activeElement === last) {
                        e.preventDefault();
                        first.focus();
                    }
                }
            });

            const offEscape = onEscape(() => {
                if(btnOpenModal) {
                    const btn = btnOpenModal.querySelector('a');
                    if(btn) {
                        btn.focus();
                    } else {
                        btnOpenModal.focus();
                    }
                    
                }
            });

            function onEscape(handler) {
                function listener(e) {
                    if (e.key === 'Escape' || e.key === 'Esc' || e.code === 'Escape') {
                        handler(e);
                    }
                }
                container.addEventListener('keydown', listener);
                return () => container.removeEventListener('keydown', listener);
            }
        }

    function getFocusableElements(container) {
        return Array.from(
            container.querySelectorAll(
                `
                a[href]:not([tabindex="-1"]),
                button:not([disabled]):not([tabindex="-1"]),
                area[href],
                input:not([disabled]):not([type="hidden"]),
                select:not([disabled]),
                textarea:not([disabled]),
                [tabindex]:not([tabindex="-1"]),
                iframe,
                audio[controls],
                video[controls],
                summary,
                [contenteditable]
                `
            )
        );
    }

    function fixThumbnailAccessibility() {
        if (!window.location.pathname.includes('/collections/') && !window.location.pathname.includes('/search')) return;

        let productList = null;

        function addButtonRoleToGridIcons() {
            const gridViewIndex = 0;
            const container = document.querySelector('.boost-sd__view-as');
            if(!container || (container && container.getAttribute('applied'))) return;
            container.setAttribute('applied', 'true');
            
            const btns = document.querySelectorAll('.boost-sd__view-as .boost-sd__view-as-icon');
            btns.forEach((btn, index) => {
                const isActive = index === gridViewIndex;
                btn.setAttribute('role', 'button');
                btn.setAttribute('tabindex', '0');
                btn.setAttribute('aria-label', isActive ? 'Grid view' : 'List view');
                btn.setAttribute('aria-pressed', isActive);
                btn.addEventListener('click', () => {
                    setTimeout(() => {
                        btns.forEach((item) => {
                            item.setAttribute('aria-pressed', item.classList.contains('boost-sd__view-as-icon--active'));
                        });
                    }, 100);
                });

                btn.addEventListener('keydown', (e) => {
                    if(e.key === 'Enter') {
                        e.preventDefault(); 
                        btn.click();
                    }
                });
            });
            document.querySelectorAll('.boost-sd__view-as .boost-sd__tooltip-content').forEach((btn, index) => {
                btn.setAttribute('aria-hidden', 'true');
            });
        }

        function fixFilterDropdown() {
            const combobox = document.querySelector('.boost-sd__sorting-button');
            const listbox = document.querySelector('.boost-sd__sorting-list');
            if(combobox && listbox) {
                combobox.setAttribute('role', 'combobox');
                combobox.setAttribute('aria-haspopup', 'listbox');
                combobox.setAttribute('aria-expanded', 'false');
                combobox.setAttribute('aria-owns', 'sort-list');
                combobox.setAttribute('tabindex', '0');


                listbox.setAttribute('role', 'listbox');
                listbox.id = 'sort-list';

                const options = listbox.querySelectorAll('li');

                options.forEach(element => element.setAttribute('role', 'option'));

                const valueSpan = combobox.querySelector('.boost-sd__sorting-value');

                let isOpen = combobox.getAttribute('aria-expanded') === 'true';
                let currentIndex = Array.from(options).findIndex(opt => opt.getAttribute('aria-selected') === 'true' || opt.classList.contains('boost-sd__sorting-option--active'));

                // Toggle open/close
                function toggleList(open) {
                    isOpen = open;
                    combobox.setAttribute('aria-expanded', String(open));
                    listbox.style.display = open ? 'block' : 'none';
                    if (open) {
                        options[currentIndex].focus();
                    }
                }

                // Update selection
                function selectOption(index) {
                    options.forEach(opt => opt.removeAttribute('aria-selected'));
                    options[index].setAttribute('aria-selected', 'true');
                    options[index].click();
                    currentIndex = index;
                    valueSpan.textContent = options[index].textContent;
                    toggleList(false);
                    combobox.focus();
                }

                // Make options focusable
                options.forEach(opt => opt.setAttribute('tabindex', '-1'));

                // Handle combobox button click
                combobox.addEventListener('click', e => {
                    if (e.target.closest('[role="option"]')) return; // let option handler run
                    toggleList(!isOpen);
                });

                // Handle keyboard on combobox
                combobox.addEventListener('keydown', e => {

                })

                combobox.addEventListener('keydown', e => {
                    if (!isOpen && (e.key === 'Enter' || e.key === ' ')) {
                        e.preventDefault();
                        if(!e.target.classList.contains('boost-sd__sorting-option')) {
                            toggleList(true);
                        }
                    } else if (isOpen) {
                        switch (e.key) {
                            case 'ArrowDown':
                                e.preventDefault();
                                currentIndex = (currentIndex + 1) % options.length;
                                options[currentIndex].focus();
                                break;
                            case 'ArrowUp':
                                e.preventDefault();
                                currentIndex = (currentIndex - 1 + options.length) % options.length;
                                options[currentIndex].focus();
                                break;
                            case 'Enter':
                            case ' ':
                                e.preventDefault();
                                selectOption(currentIndex);
                                break;
                            case 'Escape':
                                e.preventDefault();
                                toggleList(false);
                                break;
                        }
                    }
                });

                // Handle clicking on an option
                options.forEach((opt, index) => {
                    opt.addEventListener('click', () => selectOption(index));
                    opt.addEventListener('keydown', e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        selectOption(index);
                        }
                    });
                });

                // Close list if clicked outside
                document.addEventListener('click', e => {
                    if (!combobox.contains(e.target)) {
                        toggleList(false);
                    }
                });

                // Initialize closed
                toggleList(false);

                const updateLabel = () => {
                    const value = combobox.querySelector('.boost-sd__sorting-value');
                    const text = value && value.textContent.trim() ? value.textContent.trim() : '';
                    combobox.setAttribute('aria-label', text ? `Sort by ${text}` : 'Sort by');
                };

                updateLabel();

                new MutationObserver(() => 
                    updateLabel()
                ).observe(combobox, { childList: true, subtree: true});
            }
        }

        function changeProductsCountToH2() {
            const subtitleCount = document.querySelector('.boost-sd__toolbar-item .boost-sd__product-count');
            if(subtitleCount) {
                subtitleCount.setAttribute('aria-level', '2');
                subtitleCount.setAttribute('role', 'heading');
            }
        }

        function updateAriaLabelSearchFormItems() {
            const form = document.querySelector('.boost-sd__search-form');
            if(form) {
                const searchInput = form.querySelector('input');
                const searchBtn = form.querySelector('.boost-sd__button--as-search');
                if(searchInput && searchBtn) {
                    searchInput.setAttribute('aria-label', 'Search');
                    searchBtn.setAttribute('aria-label', 'Search');
                }
            }
        }

        function getProductList() {
            if (!productList) {
                productList = document.querySelector('.boost-sd__product-list');
            }
            return productList;
        }

        function restructureProductItem(item) {
            if (item.classList.contains('structure-fixed')) {
                return;
            }
            item.removeAttribute('aria-label');


            
            extraProductContent(item);
            const mainLink = item.querySelector('.boost-sd__product-link-image');
            const secondLink = item.querySelector('a:not(.boost-sd__product-link-image)');

            if(mainLink && secondLink) {
                // replaceLinkWithSpan(mainLink, secondLink);
                mainLink.setAttribute('role', 'none')
                mainLink.setAttribute('tabindex', '-1');
                mainLink.setAttribute('href', mainLink.getAttribute('href') + '?')

            }


            const imageContainer = item.querySelector('.boost-sd__product-item-list-view-layout-image');
            if(imageContainer && item.closest('.boost-sd__product-item-list-view-layout')) {
                imageContainer.setAttribute('aria-hidden', 'true');
            }

            const price = item.querySelector('.boost-sd__product-price-content');
            if(price) {
                const compare = price.querySelector('.boost-sd__format-currency--price-compare');
                if(compare) {
                    const currentPrice = price.querySelector(':scope > .boost-sd__format-currency');

                    const currentPriceSpan = document.createElement('span');
                    currentPriceSpan.classList.add('visually-hidden');
                    currentPriceSpan.innerText = `Current price`;
                    const originalPriceSpan = document.createElement('span');
                    originalPriceSpan.classList.add('visually-hidden');
                    originalPriceSpan.innerText = `Original price`;

                    currentPrice.prepend(currentPriceSpan);
                    compare.prepend(originalPriceSpan);
                }
            }
            item.classList.add('structure-fixed');
        }

        function clearImageAlts() {
            const productImages = document.querySelectorAll('.boost-sd__product-item .boost-sd__product-image-img[alt]:not([alt=""]), .boost-sd__product-item-list-view-layout .boost-sd__product-image-img[alt]:not([alt=""])');
            productImages.forEach(img => {
                const parent = img.closest('.boost-sd__product-item-list-view-layout-image, .boost-sd__product-image');
                if(parent) {
                    parent.setAttribute('aria-hidden', 'true');
                }
                img.alt = '';
            });
        }

        function addAccessibilityRoles() {
            const list = getProductList();
            if (list && !list.hasAttribute('role')) {
                list.setAttribute('role', 'list');
                list.setAttribute('aria-label', getCollectionName());
            }

            const productItems = document.querySelectorAll('.boost-sd__product-item:not([role]), .boost-sd__product-item-list-view-layout:not([role])');
            productItems.forEach(item => {
                item.setAttribute('role', 'listitem');
            });
        }

        function addQuickViewLabels() {
            const quickViewButtons = document.querySelectorAll('.boost-sd__btn-quick-view:not([aria-label])');
            quickViewButtons.forEach(button => {
                button.setAttribute('aria-label', 'Quick view');
            });
        }

        function addPaginationLabels() {
            const pagination = document.querySelector('.boost-sd__pagination');
            if (!pagination) return;

            const allPageButtons = pagination.querySelectorAll('.boost-sd__pagination-number');

            allPageButtons.forEach((button, index) => {
                const pageNum = parseInt(button.textContent.trim());
                const isDisabled = button.classList.contains('boost-sd__pagination-number--disabled');
                const hasActiveClass = button.classList.contains('boost-sd__pagination-number--active');

                if (!isNaN(pageNum) && !isDisabled) {
                    const newLabel = `Page ${pageNum} of ${allPageButtons.length}`;
                    button.setAttribute('aria-label', newLabel);
                    button.setAttribute('aria-current', hasActiveClass ? 'true' : 'false');
                } else {
                    button.setAttribute('aria-hidden', 'true');
                    button.setAttribute('tabindex', '-1');
                }
            });

            const isEllipsis = Array.from(allPageButtons).some(item => item.classList.contains('boost-sd__pagination-number--disabled'));
            const activeElement = Array.from(allPageButtons).find(item => item.classList.contains('boost-sd__pagination-number--active'));

            const prevButton = pagination.querySelector('.boost-sd__pagination-button--prev');
            if (!isEllipsis) {
                prevButton.setAttribute('aria-hidden', 'true');
                prevButton.setAttribute('tabindex', '-1');
            } else {
                if(activeElement.innerText !== '1') {
                    prevButton.setAttribute('aria-label', `Page ${(+activeElement.innerText) - 1}`);
                }
            }

            const nextButton = pagination.querySelector('.boost-sd__pagination-button--next');
            if (!isEllipsis) {
                nextButton.setAttribute('aria-hidden', 'true');
                nextButton.setAttribute('tabindex', '-1');
            } else {
                const nextElement = activeElement.nextElementSibling;
                if(nextElement && (+nextElement.innerText)) {
                    nextButton.setAttribute('aria-label', `Page ${(+nextElement.innerText)}`)
                }
                
            }

            if (!pagination.hasAttribute('role')) {
                pagination.setAttribute('role', 'navigation');
                pagination.setAttribute('aria-label', 'Pagination');
            }
        }

        function extraProductContent(product) {
            let titleLink = product.querySelector('a:not(.boost-sd__product-link-image)');
            const extraProductContent = product.querySelector('.boost-sd__product-label');
            const randomId = Math.random().toString(16).slice(2);
            const titleText = product.querySelector('.boost-sd__product-title');
            titleText.id = 'product_title_'+randomId;
                
            // const listItemParent = produ.closest('.boost-sd__product-item-list-view-layout');
                
            if(product.classList.contains('boost-sd__product-item-list-view-layout')) {
                titleLink = product.querySelector('a.boost-sd__product-link:has(.boost-sd__product-title)');
                product.querySelectorAll('.boost-sd__product-item-list-view-layout-cta-buttons button').forEach(btn => {
                    btn.setAttribute('aria-describedby', titleText.id);
                });
            }

            // const title = element.querySelector('.boost-sd__product-title');

            // if(title) {
            //     element.setAttribute('aria-label', title.innerText);
            // }

            // const vendor = product.querySelector('.boost-sd__product-vendor');
            // const price = product.querySelector('.boost-sd__product-price, .boost-sd__product-item-list-view-layout-price');
            let ariaDescribed = undefined;
            // titleLink.setAttribute('aria-label', product.querySelector('.boost-sd__product-title')?.innerText);
            titleLink.removeAttribute('aria-label');
            // if(vendor) {
            //     vendor.id = `vendor_${randomId}`;
            //     ariaDescribed = vendor.id;
            // }

            // if(price) {
            //     price.id = `price_${randomId}`;
            //     ariaDescribed = ariaDescribed ? `${ariaDescribed} ${price.id}` : price.id;
            // }



            if(extraProductContent) {
                extraProductContent.id='extra_product_content_'+randomId;
                ariaDescribed = ariaDescribed ? `${ariaDescribed} ${extraProductContent.id}` : extraProductContent.id;
            }

            if(ariaDescribed) {
                titleLink.setAttribute('aria-describedby', ariaDescribed);
            }

            const quickViewBtn = product.querySelector('.boost-sd__btn-quick-view');
            if(quickViewBtn) {
                quickViewBtn.setAttribute('aria-describedby', titleText.id);
            }

            const selectBtn = product.querySelector('.boost-sd__button[aria-label="Select options"]');
            if(selectBtn) {
                selectBtn.setAttribute('aria-describedby', titleText.id);
            }

            const addToCartBtn = product.querySelector('.boost-sd__btn-add-to-cart');
            if(addToCartBtn) {
                addToCartBtn.setAttribute('aria-describedby', titleText.id);
            }

            // product.querySelectorAll('.boost-sd__product-link').forEach((element, index) => {
                


            // });
        }

        function getCollectionName() {
            const h1Element = document.querySelector('.boost-sd__header-title');
            if (h1Element && h1Element.textContent.trim()) {
                const collectionName = h1Element.textContent.trim();
                return `${collectionName}`;
            }
            return "Products";
        }

        function isProductProcessingComplete() {
            const list = getProductList();
            if (!list) return false;

            const unprocessedItems = list.querySelectorAll('.boost-sd__product-item:not(.structure-fixed), .boost-sd__product-item-list-view-layout:not(.structure-fixed)');
            const imagesWithAlt = list.querySelectorAll('.boost-sd__product-item .boost-sd__product-image-img[alt]:not([alt=""]), .boost-sd__product-item-list-view-layout .boost-sd__product-image-img[alt]:not([alt=""])');
            const itemsWithoutRole = list.querySelectorAll('.boost-sd__product-item:not([role]), .boost-sd__product-item-list-view-layout:not([role])');
            const buttonsWithoutLabel = list.querySelectorAll('.boost-sd__btn-quick-view:not([aria-label])');

            return unprocessedItems.length === 0 && 
                imagesWithAlt.length === 0 && 
                itemsWithoutRole.length === 0 && 
                buttonsWithoutLabel.length === 0;
        }

        function initAccessibilityObserver() {
            const list = getProductList();
            if (!list) {
                setTimeout(initAccessibilityObserver, 250);
                return;
            }

            let productObserver;
            let paginationObserver;
            let processTimeout;

            const processProductChanges = () => {
                clearTimeout(processTimeout);
                
                processTimeout = setTimeout(() => {
                    
                    const itemsToProcess = document.querySelectorAll('.boost-sd__product-item:not(.structure-fixed), .boost-sd__product-item-list-view-layout:not(.structure-fixed)');
                    itemsToProcess.forEach(restructureProductItem);

                    addButtonRoleToGridIcons();
                    changeProductsCountToH2();
                    updateAriaLabelSearchFormItems();
                    fixFilterDropdown();
                    clearImageAlts();
                    addAccessibilityRoles();
                    addQuickViewLabels();
                    addPaginationLabels();
                    
                    // setTimeout(() => {
                    //     if (isProductProcessingComplete()) {
                    //         productObserver.disconnect();
                    //     }
                    // }, 2000);
                }, 250);
            };

            const processPaginationChanges = () => {
                addPaginationLabels();
            };

            // Product observer
            productObserver = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList' || mutation.type === 'attributes') {
                        processProductChanges();
                        return;
                    }
                }
            });

            // Pagination observer
            paginationObserver = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList' || mutation.type === 'attributes') {
                        processPaginationChanges();
                        return;
                    }
                }
            });

            // Start product processing
            processProductChanges();

            // Observe product list
            productObserver.observe(list, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class']
            });

            // Observe pagination permanently
            const pagination = document.querySelector('.boost-sd__pagination');
            if (pagination) {
                processPaginationChanges();
                paginationObserver.observe(pagination, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['class']
                });
            }

            document.querySelectorAll('.boost-sd__pagination .boost-sd__pagination-number, .boost-sd__view-as .boost-sd__view-as-icon').forEach(element => {
                element.addEventListener('click', () => {
                    processProductChanges();
                });
            });
            

            

            function fixSelectedFilterItems() {
                if (!window.location.pathname.includes('/collections/') && !window.location.pathname.includes('/search')) return;
                
                const title = document.querySelector('.boost-sd__search-form-title');
                if(title && title.innerText.includes('when no search term')) {
                    title.innerText = 'Search';
                }

                const observer = new MutationObserver(() => {
                    const container = document.querySelector('.boost-sd__refine-by-vertical-refine-by');
                    
                    if(!container) return;

                    const title = container.querySelector('.boost-sd__refine-by-vertical-refine-by-heading');
                    const listContainer = container.querySelector('.boost-sd__refine-by-vertical-refine-by-list');

                    title.id = 'current_filters_title';

                    listContainer.setAttribute('aria-labelledby', title.id);
                    listContainer.setAttribute('role', 'list');

                    listContainer.querySelectorAll('.boost-sd__refine-by-vertical-refine-by-item').forEach(element => {
                        replaceChildElement(element);
                    });

                    
                    document.querySelectorAll('.boost-sd__refine-by-vertical-refine-by button').forEach(element => {
                        element.addEventListener('click', () => {
                            verifyActiveFilterlistener(observer);
                        });
                    });

                    observeChildren(listContainer, observer);

                    // observer.disconnect();
                });

                observer.observe(document.body, {
                    subtree: true,
                    childList: true
                });


                function verifyActiveFilterlistener(observer) {
                    setTimeout(() => {
                        const activeFiltersQty = document.querySelectorAll('.boost-sd__refine-by-vertical-refine-by button').length;
                        if(activeFiltersQty === 0) {
                            observer.observe(document.body, {
                                subtree: true,
                                childList: true
                            });
                        }
                    }, 500);
                }

                function replaceChildElement(element) {
                    const btnText = element.querySelector('.boost-sd__refine-by-vertical-refine-by-type');
                    btnText.setAttribute('aria-hidden', 'true');
                    const btnLabelText = 'Remove filter, ' + btnText.innerText;

                    element.setAttribute('tabindex', '-1');
                    element.setAttribute('role', 'listitem');

                    const button = element.querySelector('svg');
                    button.setAttribute('tabindex', '0');
                    button.setAttribute('role', 'button');
                    button.setAttribute('aria-label', btnLabelText);

                    button.addEventListener('click', () => element.click());
                    element.removeAttribute('aria-label');
                }

                function observeChildren(container, firstObserver) {
                    const childObserver = new MutationObserver(mutations => {
                        mutations.forEach(mutation => {
                            mutation.addedNodes.forEach(node => {
                                if (node.nodeType === 1) {
                                    replaceChildElement(node);
                                    processProductChanges();
                                };
                            });
                        });
                    });

                    childObserver.observe(container, { childList: true, subtree: true });

                    const parent = container.parentNode;
                    if (parent.parentNode) {
                        const parentObserver = new MutationObserver(mutations => {
                            mutations.forEach(mutation => {
                                mutation.removedNodes.forEach(node => {
                                if (node === parent) {
                                    verifyActiveFilterlistener(firstObserver);
                                    processProductChanges();
                                    parentObserver.disconnect();
                                    childObserver.disconnect();
                                }
                                });
                            });
                        });
                        parentObserver.observe(parent.parentNode, { childList: true });
                    }
                }
            }

            fixSelectedFilterItems();
        }

        initAccessibilityObserver();
    }

    fixThumbnailAccessibility();

    //function improved by Micaela Avigliano
    function cartWidgetAccessibility() {
        const cartSection = document.getElementById('shopify-section-cart_widget');
        const cartCanvas = document.getElementById('nt_cart_canvas');
        const cartLink = document.querySelector('a[data-id="#nt_cart_canvas"]');
        const active = cartCanvas.classList.contains('current_hover');
        const minicartWrap = cartCanvas.querySelector('.mini_cart_wrap');
        const minicartNoteElement = cartCanvas.querySelector('.mini_cart_note.pe_none');
        const minicartDisElement = cartCanvas.querySelector('.mini_cart_dis.pe_none')

        // first, we are going to hide the interactive elements we do not want to loop.
        minicartDisElement.style.display = 'none';
        minicartNoteElement.style.display = 'none';

        // Second, when the cart icon is pressed using the key Enter we are going to select the activeContainer
        cartLink.addEventListener('keydown', (e) => {
            if(e.code === "Enter") {
                let activeContainer = cartCanvas.querySelector('.mini_cart_wrap:not(.pe_none), .mini_cart_note:not(.pe_none), .mini_cart_dis:not(.pe_none)');

                active ? cartCanvas.classList.remove('current_hover') : cartCanvas.classList.add('current_hover');

                // Third, if the active container has the class .mini_cart_wrap we are going to set it the attribute aria-modal and so the screen reader users are
                // aware that it is a and we are going to set it a tabindex="-1" to remove it from the normal keyboard navigation and finally we
                // are going to trigger the function to trap the focus.
                if(activeContainer.classList.contains('mini_cart_wrap')) {
                    activeContainer = activeContainer.querySelector(':scope > div:not(.dn)');
                    cartCanvas.setAttribute('aria-modal', 'true')
                    cartCanvas.setAttribute('tabindex', '-1')
                    trapFocus(minicartWrap, cartLink);
                }
            }
        });

        if (!cartSection || !cartCanvas) {
            return;
        }

        cartCanvas.addEventListener('keydown', (e) => {
            if (e.code === "Escape") {
                cartCanvas.classList.remove('current_hover')
                cartCanvas.setAttribute('aria-modal', 'false')
                cartLink.focus()
            }
        })

        const initialVisible = cartCanvas.classList.contains('current_hover');

        if (initialVisible) {
            isVisible ? cartCanvas.removeAttribute('tabindex') : cartCanvas.setAttribute('tabindex', '-1');
            cartCanvas.querySelectorAll('a[href], input:not([type="hidden"]), select, textarea, button, [tabindex], .mini_cart_dis, .mini_cart_note').forEach(element => {
                element.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
                isVisible ? element.removeAttribute('tabindex') : element.setAttribute('tabindex', '-1');
            });

            cartCanvas.setAttribute('tabindex', '-1');
        }
    }

    function fixSearchPopup() {
        const searchBtn = document.querySelector('.icon_search');
        if(searchBtn) {
            searchBtn.addEventListener('click', () => {
                const searchContainer = document.querySelector('#nt_search_canvas');
                const searchBtnInner = searchContainer.querySelector('.search_header__submit');
                const searchInput = searchContainer.querySelector('.search_header__input');
                if(searchContainer) {
                    searchBtnInner.setAttribute('tabindex', '-1');
                    searchBtnInner.setAttribute('aria-hidden', 'true');
                    trapFocus(searchContainer, searchBtn, [searchInput]);
                }
            });
        }
    }

    fixSearchPopup();

    function closeMenusOnEscape(e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
            const nav = document.querySelector('.nt_navigation');
            nav.classList.add('hover-disabled');
            
            document.querySelectorAll('.nt_menu .has-children').forEach(function(item) {
                item.classList.remove('is_hover');
                item.classList.remove('menu_item_hover');
                
                const link = item.querySelector('.menu_link_icon');
                const submenu = link.nextElementSibling;
                if (link && !submenu.classList.contains('li_hovered')) link.setAttribute('aria-expanded', 'false');
            });
            
            function reactivateHover() {
                nav.classList.remove('hover-disabled');
                nav.removeEventListener('mouseleave', reactivateHover);
            }
            
            nav.addEventListener('mouseleave', reactivateHover);
        }
    }
            
    document.addEventListener('keydown', closeMenusOnEscape);

    function listeningToMenuLinkIcon() {
        const icons = document.querySelectorAll('.menu_link_icon');
        icons.forEach(element => {
            const parentLi = element.parentElement;
            const nextElement = element.nextElementSibling;
        
            parentLi.addEventListener('mouseenter', function() {
                element.setAttribute('aria-expanded', 'true');
            });
            
            parentLi.addEventListener('mouseleave', function() {
                if (!nextElement.classList.contains('li_hovered')) element.setAttribute('aria-expanded', 'false');
            });

            element.addEventListener('keydown', (e) => {
                if(e.key === 'Enter') {
                    element.click();
                }
            });
            
            element.addEventListener('click', () => {

                if(nextElement) {
                    const offEscape = onEscape(() => {
                        nextElement.classList.remove('li_hovered');
                        element.setAttribute('aria-expanded', 'false');
                    });

                    function onEscape(handler) {
                        function listener(e) {
                            if (e.key === 'Escape' || e.key === 'Esc' || e.code === 'Escape') {
                                handler(e);
                            }
                        }
                        nextElement.addEventListener('keydown', listener);
                        return () => nextElement.removeEventListener('keydown', listener);
                    }
                    nextElement.addEventListener('keydown');

                    if(!nextElement.classList.contains('li_hovered')) {
                        nextElement.classList.add('li_hovered')
                        element.setAttribute('aria-expanded', 'true');
                        icons.forEach(link => {
                            const linkText = link.previousElementSibling;
                            const linkTextNext = link.nextElementSibling;
                            const previousText = element.previousElementSibling;

                            if(linkText.innerText !== previousText.innerText) {
                                linkTextNext.classList.remove('li_hovered')
                                link.setAttribute('aria-expanded', 'true');
                            }
                        });
                    } else {
                        nextElement.classList.remove('li_hovered');
                        element.setAttribute('aria-expanded', 'false');
                    }
                }
            });

        });
    }

    listeningToMenuLinkIcon();
    
    // cartWidgetAccessibility();

    function fixPopup1(){
        const observer = new MutationObserver(() => {
                const popupContainer = document.querySelector('[data-testid="POPUP"]');
                if (!popupContainer) return;

                const richTexts = popupContainer.querySelectorAll('[id^="rich-text"]');
                const popupTitle = richTexts[0]?.querySelector('span');
                if (popupTitle) {
                    const h1 = document.createElement('h1');
                    h1.style.cssText = popupTitle.style.cssText;
                    h1.textContent = popupTitle.textContent;
                    popupTitle.parentNode.replaceChild(h1, popupTitle);
                }

                const errorMessage = popupContainer.querySelector('span[role="alert"]');
                if (errorMessage) {
                    errorMessage.textContent = 'Enter an email address in the format example@example.com';
                }

                setTimeout(() => {
                    const emailInput = popupContainer.querySelector('input[type="email"]');
                    if (emailInput && emailInput.placeholder) {
                        const currentPlaceholder = emailInput.placeholder;
                        if (!currentPlaceholder.includes('*')) {
                            emailInput.placeholder = currentPlaceholder + ' *';
                        }
                    }

                    const buttons = popupContainer.querySelectorAll('button[type="button"]:not(.klaviyo-close-form)');
                    const signUpButton = buttons[0];
                    const richTexts = popupContainer.querySelectorAll('[id^="rich-text"]');
                    const disclaimer = richTexts[richTexts.length - 1];
                    if (signUpButton && disclaimer && disclaimer.id) {
                        signUpButton.setAttribute('aria-describedby', disclaimer.id);
                    }

                    const disclaimerLinks = popupContainer.querySelectorAll('p a[href]');
                    disclaimerLinks.forEach(link => {
                        const linkText = link.textContent.trim();
                        if (linkText === 'Privacy Policy' || linkText === 'Terms') {
                            link.style.textDecoration = 'underline';
                        }
                    });
                }, 300);

                const errorObserver = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        mutation.addedNodes.forEach((node) => {
                            if (node.nodeType === 1) {
                                const errorMsg = node.querySelector('span[role="alert"]') ||
                                    (node.matches && node.matches('span[role="alert"]') ? node : null);
                                if (errorMsg) {
                                    errorMsg.textContent = 'Enter an email address in the format example@example.com';
                                }

                                const links = node.querySelectorAll('p a[href]') ||
                                    (node.matches && node.matches('p a[href]') ? [node] : []);
                                links.forEach(link => {
                                    const linkText = link.textContent.trim();
                                    if (linkText === 'Privacy Policy' || linkText === 'Terms') {
                                        link.style.textDecoration = 'underline';
                                    }
                                });
                            }
                        });
                    });
                });

                errorObserver.observe(popupContainer, {
                    childList: true,
                    subtree: true
                });
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }


        //     const observer = new MutationObserver(() => {
        //         const popup = document.querySelector('.needsclick[role="dialog"] [data-testid="POPUP"]');
        //         if(!popup) return;

        //         const title = popup.querySelector('[id^="rich-text"] span');
        //         if(title) {
        //             const h1 = document.createElement('h1');
        //             h1.style.cssText = title.style.cssText;
        //             h1.textContent = title.textContent;
        //             title.parentNode.replaceChild(h1, title);
        //         }
        //         setTimeout(() =>{
        //             const emailInput = popup.querySelector('input:not([data-testid="phoneNumberInput"])');
        //             if (emailInput && emailInput.placeholder) {
        //                 const currentPlaceholder = emailInput.placeholder;
        //                 if (!currentPlaceholder.includes('*')) {
        //                     emailInput.placeholder = currentPlaceholder + ' *';
        //                 }
        //             }

        //             popup.querySelectorAll('a').forEach(element => {
        //                 element.style.textDecoration = 'underline';
        //             });
        //         }, 300);
        //         const errorObserver = new MutationObserver((mutations) => {
        //             mutations.forEach((mutation) => {
        //                 mutation.addedNodes.forEach((node) => {
        //                     if (node.nodeType === 1) {
        //                         const errorMsg = node.querySelector('span[role="alert"]') || (node.matches && node.matches('span[role="alert"]') ? node : null);
        //                         if (errorMsg) {
        //                             errorMsg.textContent = 'Enter an email address in the format example@example.com';
        //                         }
        //                     }
        //                 });
        //             });
        //         });

        //         errorObserver.observe(popup, {
        //             childList: true,
        //             subtree: true
        //         });
        //     });
            
        //     observer.observe(document.body, {
        //         childList: true,
        //         subtree: true
        //     });
        // }
    fixPopup1();

    function fixPopupPrivacy() {
        const observer = new MutationObserver(() => {
            const popup = document.querySelector('#shopify-pc__banner');
            if(!popup) return;

            const title = popup.querySelector('#shopify-pc__banner__body-title');
            if(title) {
                const h1 = document.createElement('h1');
                copyAttributes(title, h1);
                h1.innerText = title.innerText;
                title.replaceWith(h1);
            }

            trapFocus(popup);
            observer.disconnect();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    fixPopupPrivacy();

    function fixKlaviyoNewsletterTabOrder() {

        function setupErrorMessages(form) {
            const errorMessage = form.querySelector('.shopify-error.error_message');

            // Create checkbox error message if it doesn't exist
            let checkboxError = form.querySelector('.checkbox-error-message');
            if (!checkboxError) {
                checkboxError = document.createElement('span');
                checkboxError.className = 'checkbox-error-message';
                checkboxError.style.cssText = 'color: #ffffff; font-size: 12px; margin-left: 8px; display: none;';
                checkboxError.textContent = 'This field is required';

                const checkboxLabel = form.querySelector('label[for*="new_check_agree"]');
                if (checkboxLabel) {
                    checkboxLabel.appendChild(checkboxError);
                }
            }

            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {

                        // Handle error_css_email
                        if (form.classList.contains('error_css_email')) {
                            if (errorMessage) {
                                errorMessage.textContent = 'Enter an email address in the format example@example.com';
                                errorMessage.classList.remove('dn');
                            }
                        } else if (errorMessage) {
                            errorMessage.classList.add('dn');
                        }

                        // Handle error_css_checkbox
                        if (form.classList.contains('error_css_checkbox')) {
                            if (checkboxError) {
                                checkboxError.style.display = 'inline';
                            }
                        } else if (checkboxError) {
                            checkboxError.style.display = 'none';
                        }
                    }
                });
            });

            observer.observe(form, {
                attributes: true,
                attributeFilter: ['class']
            });
        }

        const existingForms = document.querySelectorAll('footer form.klaviyo_sub_frm');
        existingForms.forEach(form => {
            setupErrorMessages(form);
        });

        // Observer for dynamic Klaviyo forms in footer
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1) {
                        const form = node.querySelector && node.querySelector('footer form.klaviyo_sub_frm');
                        if (form) {
                            setupErrorMessages(form);
                        }
                        if (node.matches && node.matches('footer form.klaviyo_sub_frm')) {
                            setupErrorMessages(node);
                        }
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    fixKlaviyoNewsletterTabOrder();

    function fixTabListProduct() {
        const container = document.querySelector('#shopify-section-pr_description');
        if(!container) return;

        const tablist = container.querySelector('[role="tablist"]');
        const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
        const panels = tabs.map(t => document.getElementById(t.getAttribute('aria-controls')));

        tabs.forEach(element => {
            const parent = element.parentElement;
            const isActive = parent.classList.contains('active');
            element.setAttribute('tabindex', isActive ? '0' : '-1');
            element.setAttribute('aria-selected', isActive);
        });

        function activateTab(tab) {
            tabs.forEach((t, i) => {
            const selected = t === tab;
            t.setAttribute('aria-selected', selected);
            t.tabIndex = selected ? 0 : -1;
            panels[i].hidden = !selected;
            });
            tab.focus();
        }

        tablist.addEventListener('click', (e) => {
            if (e.target.getAttribute('role') === 'tab') activateTab(e.target);
        });

        tablist.addEventListener('keydown', (e) => {
            const i = tabs.indexOf(document.activeElement);
            if (i === -1) return;

            let next = null;
            switch (e.key) {
            case 'ArrowRight': next = tabs[(i + 1) % tabs.length]; break;
            case 'ArrowLeft':  next = tabs[(i - 1 + tabs.length) % tabs.length]; break;
            case 'Home':       next = tabs[0]; break;
            case 'End':        next = tabs[tabs.length - 1]; break;
            case 'Enter':
            case ' ':          activateTab(tabs[i]); return;
            default: return;
            }
            e.preventDefault();
            next.focus();
        });

        tabs.forEach(t => t.addEventListener('keyup', e => {
            if (e.key === 'Enter') activateTab(e.currentTarget);
        }));
    }

    fixTabListProduct();

    function fixProductImagesDisplay() {
        const productContainer = document.querySelector('.product');
        if(!productContainer) return;

        const linkReview = productContainer.querySelector('.rating_sp_kl');
        if(linkReview) {
            linkReview.setAttribute('tabindex', '-1');
            linkReview.setAttribute('aria-hidden', 'true');
        }

        const observer = new MutationObserver(() => {
            const btns = productContainer.querySelectorAll('.product-images .n-item');
            if(btns.length === 0) return;
            const parent = btns[0].closest('.product-images');
            const globalStatus = document.querySelector('#invisible-alert');

            parent.addEventListener('focusin', () => {
                globalStatus.setAttribute('aria-hidden', 'false');
            });

            parent.addEventListener('focusout', () => {
                globalStatus.setAttribute('aria-hidden', 'true');
            });

            const imgs = productContainer.querySelectorAll('.flickity-slider .p-item > img');
            imgs.forEach((img, index) => {
                img.setAttribute('alt', `Product image ${index + 1} of ${imgs.length}`)
            });;

            const openGalleryBtn = productContainer.querySelector('.p_group_btns .show_btn_pr_gallery');
            openGalleryBtn.setAttribute('aria-label', `Open image 1 of ${btns.length} in modal`);
            openGalleryBtn.addEventListener('click', () => fixImageViewModal(openGalleryBtn));

            const updateStatus = () => {
                const isSelected = productContainer.querySelector('.flickity-slider .img_ptw.is-selected img');
                    const img = isSelected;
                    globalStatus.innerText = img.getAttribute('alt');
            };

            btns.forEach((element, index) => {
                setImageBtnAttributes(element, index, btns.length);
                element.addEventListener('click', () => {
                    // btns.forEach(btn =>  btn.setAttribute('aria-hidden', 'false'));
                    openGalleryBtn.setAttribute('aria-label', `Open image ${index+1} of ${btns.length} in modal`);
                });

                new MutationObserver(() => {
                    if(element.getAttribute('aria-hidden') !== 'true'){
                        element.setAttribute('aria-hidden', 'true')
                    }
                    
                }).observe(element, {attributes: true, attributeFilter: ['aria-hidden']});
            });

            productContainer.querySelectorAll('.flickity-button').forEach(btn => {
                const label = btn.classList.contains('next') ? 'Next product image' : 'Previous product image';
                btn.setAttribute('aria-label', label);
                btn.addEventListener('click', () => updateStatus());
                btn.addEventListener('keydown', (e) => {
                    if(e.key === 'Enter') {
                        updateStatus();
                    }
                })
            });

            const title = productContainer.querySelector('.product_title').innerText;

            productContainer.querySelectorAll('.btn_pnav_prev, .btn_pnav_next').forEach(element => {
                element.setAttribute('tabindex', '-1');

                element.setAttribute('aria-hidden', 'true');
            });

            productContainer.querySelectorAll('.p-thumb').forEach(element => {
                element.removeAttribute('tabindex');

                // element.setAttribute('aria-hidden', 'true');
            });

            setTimeout(() => {
                const containerimg =  productContainer.querySelector('.p-thumb.images .flickity-viewport');
                if(containerimg) {
                    containerimg.setAttribute('aria-hidden', 'true')
                }
            }, 2000);
            

            const flickity = productContainer.querySelector('.p-nav');
            if(flickity) {
                flickity.removeAttribute('tabindex');
            }

            observer.disconnect();
        });

        observer.observe(productContainer, {
            subtree: true,
            childList: true
        });

        function setImageBtnAttributes(element, index, total) {
            if(!element) return;
            // element.setAttribute('role', 'button');
            // element.setAttribute('tabindex', hide ? '-1' : '0');
            // element.setAttribute('aria-hidden','false');
            // element.setAttribute('image-index', index+1);
            // element.setAttribute('aria-label', `Load image ${index+1} of ${total} in gallery view`);
            element.setAttribute('aria-hidden', 'true')
        }

        function fixImageViewModal(openGalleryBtn) {
            setTimeout(() => {
                const modal = document.querySelector('.pswp');
                if(!modal) return;
                modal.setAttribute('aria-label', 'Product Showcase');

                const btnsModal = modal.querySelectorAll('.pswp .pswp__thumbnails .pswp_thumb_item');
                btnsModal.forEach((element, index) => {
                    setImageBtnAttributes(element, index, btnsModal.length);
                });

                const closeBtn = modal.querySelector('.pswp__button--close');
                closeBtn.addEventListener('click', () => {
                    openGalleryBtn.focus();
                });

                modal.querySelectorAll('.pswp__button--close, .pswp__button--share, .pswp__button--fs, .pswp__button--zoom').forEach(element => {
                    element.setAttribute('aria-label', element.getAttribute('title'));
                });

                trapFocus(modal, openGalleryBtn);
            }, 500)
        }
    }

    fixProductImagesDisplay();

    function fixProductSlider() {
        const elements = document.querySelectorAll('.related.product-extra');
        elements.forEach((element, index) => {
            
            const observer = new MutationObserver(() => {
                const sliderContainer = element.querySelector('.products');
                if(!sliderContainer) return;

                sliderContainer.removeAttribute('tabindex');

                // const dots = fixFlickityDots(sliderContainer);

                dots.forEach(dot => {
                    dot.addEventListener('click', () => {
                            setTimeout(() => {
                                sliderContainer.querySelectorAll('.product').forEach((product, index) => {
                                    const quickViewBtn = product.querySelector('.nt_add_qv');
                                    if(quickViewBtn) {
                                        quickViewListener(quickViewBtn);
                                    }
                                    const isActive = product.getAttribute('aria-hidden') != 'true';
                                    updateVisibiliteAttributes(product, isActive);
                                        const newChatItemObserver = new MutationObserver((mutations) => {
                                            mutations.forEach((mutation) => {
                                                mutation.addedNodes.forEach((node) => {
                                                    if (node.nodeType === 1) {
                                                        updateVisibiliteAttributes(node, isActive);
                                                        quickViewListener(node);
                                                    }
                                                });
                                            });
                                        });

                                        newChatItemObserver.observe(product, {
                                            childList: true,
                                            subtree: true
                                        });
                                });
                            },400);
                        });
                });

                sliderContainer.querySelectorAll('.flickity-button').forEach(element => {
                    element.setAttribute('aria-hidden', 'true');
                    element.setAttribute('tabindex', '-1');
                });
                
                sliderContainer.querySelectorAll('.product').forEach((product, index) => {
                    const quickViewBtn = product.querySelector('.nt_add_qv');
                    if(quickViewBtn) {
                        quickViewListener(quickViewBtn);
                    }

                    const isActive = product.getAttribute('aria-hidden') != 'true';
                    updateVisibiliteAttributes(product, isActive);
                        const newChatItemObserver = new MutationObserver((mutations) => {
                            mutations.forEach((mutation) => {
                                mutation.addedNodes.forEach((node) => {
                                    if (node.nodeType === 1) {
                                        updateVisibiliteAttributes(node, isActive);
                                        quickViewListener(node.querySelector('.nt_add_qv'));
                                    }
                                });
                            });
                        });

                        newChatItemObserver.observe(product, {
                            childList: true,
                            subtree: true
                        });
                });
                

                observer.disconnect();
            });

            observer.observe(element, {
                childList: true,
                subtree: true
            });
        });

        function updateVisibiliteAttributes(element, isActive) {
            if(!element) return;
            element.setAttribute('aria-hidden', isActive? 'false' : 'true');
            isActive ? element.removeAttribute('tabindex') : element.setAttribute('tabindex', '-1');

            const focusableElements = element.querySelectorAll('a, button, .input-text, [tabindex="0"]');

            if(focusableElements.length === 0) return;

            focusableElements.forEach(item => {
                item.setAttribute('aria-hidden', isActive? 'false' : 'true');
                isActive ? item.removeAttribute('tabindex') : item.setAttribute('tabindex', '-1');
            });
        }
    }

    // fixProductSlider();

    function fixBlogList() {
        const blogContainer = document.querySelector('.dib-post-wrap');

        if (!blogContainer) return;

        const searchLink = document.querySelector('.dib-search-toggle a');
        if (searchLink) {
            searchLink.setAttribute('aria-label', 'Search');
            searchLink.style.padding = '5px';
            const parentLi = searchLink.parentNode;
            parentLi.style.display = 'flex';
            parentLi.style.alignItems = 'center';
            const svg = searchLink.querySelector('label svg');
            const label = svg.parentNode;
            label.replaceWith(svg);
        }

        blogContainer.setAttribute('role', 'list');
        blogContainer.querySelectorAll(':scope > a').forEach(element => {
            element.removeAttribute('title')
            const newLink = document.createElement('div');
            newLink.className = element.className;
            newLink.setAttribute('role', 'listitem');

            element.removeAttribute('aria-label');
            const img = element.querySelector('.dib-post-featured-image');
            if (img) {
                img.setAttribute('alt', '');
            }

            const title = element.querySelector('h2');
            if (title) {
                const newTitle = document.createElement('div');
                newTitle.className = title.className;
                newTitle.innerText = title.innerText;
                newTitle.classList.add('h2');
                title.replaceWith(newTitle);
            }

            const listText = element.querySelector('.dib-category-text');

            newLink.appendChild(element);


            if (listText && listText.innerText.length > 0) {
                const texts = listText.innerText.split('|');
                listText.innerText = '';
                listText.setAttribute('role', 'list');
                if (title) {
                    listText.setAttribute('aria-label', `${title.innerText} Categories`)
                }
                texts.forEach((text, index) => {
                    const listElement = document.createElement('span');
                    listElement.setAttribute('role', 'listitem');
                    listElement.innerText = text;
                    listElement.classList.add('dib-category-text');
                    listElement.style.display = "inline-block";
                    listText.appendChild(listElement);

                    if (texts.length !== index + 1) {
                        const separator = document.createElement('span');
                        separator.setAttribute('aria-hidden', 'true');
                        separator.innerText = '|'
                        separator.style.margin = '0 3px';
                        separator.style.display = "inline-block";
                        separator.classList.add('dib-category-text');
                        listText.appendChild(separator);
                    }

                });
                newLink.appendChild(listText);
            }

            blogContainer.appendChild(newLink);
        });

        const pagination = document.querySelector('.dib-pagination');
        if (pagination) {
            const links = pagination.querySelectorAll('a, .dib-pagination-current');
            const totalPages = links[links.length - 1].innerText;
            links.forEach((link) => {
                link.setAttribute('aria-label', `Page ${link.innerText} of ${totalPages}`);
                link.setAttribute('aria-current', link.classList.contains('dib-pagination-current') ? 'true' : 'false');
                if (link.classList.contains('dib-pagination-current')) {
                    link.setAttribute('role', 'link');
                    link.setAttribute('tabindex', '0');
                }
            });

            const paginationNav = document.createElement('nav');
            paginationNav.setAttribute('aria-label', 'Blog Pagination');
            paginationNav.className = pagination.className;
            paginationNav.innerHTML = pagination.innerHTML;
            pagination.replaceWith(paginationNav);
        }


    }

    fixBlogList();

    function hideHRandBR(){
        document.querySelectorAll('hr, br').forEach(element => {
            element.setAttribute('aria-hidden', 'true');
        });
    }

    hideHRandBR();


(function () {
  const isMobile = window.innerWidth < 625;
  if(!isMobile) return
  const tablist = document.querySelector('.pp_tracking_tab');
  if (!tablist) return;

  const tabs = Array.from(tablist.querySelectorAll('.pp_tracking_tab_left'));

  // ✅ Stable panels — NO data-v, NO style selectors
  const panelOrder = document.querySelector('.pp_tracking_form_order');
  const panelTracking = document.querySelector('.pp_tracking_form_number');

  const panels = [panelOrder, panelTracking];
  if (tabs.length !== 2 || panels.includes(null)) return;

  // ARIA setup
  tablist.setAttribute('role', 'tablist');

  tabs.forEach((tab, i) => {
    tab.setAttribute('role', 'tab');
    tab.id = `pp-tab-${i}`;
    tab.setAttribute('aria-controls', `pp-panel-${i}`);
    tab.tabIndex = tab.classList.contains('pp_active') ? 0 : -1;
    tab.setAttribute(
      'aria-selected',
      tab.classList.contains('pp_active') ? 'true' : 'false'
    );
  });

  panels.forEach((panel, i) => {
    panel.setAttribute('role', 'tabpanel');
    panel.id = `pp-panel-${i}`;
    panel.setAttribute('aria-labelledby', `pp-tab-${i}`);
    panel.hidden = !tabs[i].classList.contains('pp_active');
  });

  function activateTab(index) {
    tabs.forEach((tab, i) => {
      const selected = i === index;
      tab.classList.toggle('pp_active', selected);
      tab.setAttribute('aria-selected', selected);
      tab.tabIndex = selected ? 0 : -1;
    });

    panels.forEach((panel, i) => {
      panel.hidden = i !== index;
      panel.style.display = i === index ? '' : 'none';
    });

    tabs[index].focus();
    tabs[index].click();
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activateTab(index));

    tab.addEventListener('keydown', (e) => {
      let nextIndex = null;

      switch (e.key) {
        case 'ArrowRight':
          nextIndex = (index + 1) % tabs.length;
          break;
        case 'ArrowLeft':
          nextIndex = (index - 1 + tabs.length) % tabs.length;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = tabs.length - 1;
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          activateTab(index);
          return;
        default:
          return;
      }

      e.preventDefault();
      tabs[nextIndex].focus();
      tabs[nextIndex].click();
    });
  });
})();

    function fixTrackingPage() {
        const trackContainer = document.querySelector('#pp-tracking-page-app');
        if(!trackContainer) return;

        trackContainer.querySelectorAll('.pp_tracking_form_in .pp_tracking_parent').forEach((parent, index) => {
            const labelText = parent.querySelector('.pp_tracking_span');
            const input = parent.querySelector('input');
            if(labelText && input) {
                labelText.innerText = labelText.innerText + ' *';
                labelText.id = 'label_id_'+index;
                input.setAttribute('aria-labelledby', labelText.id);
                if(input.getAttribute('name') === 'email') {
                    input.setAttribute('autocomplete', 'email');
                }
            }
        });

        const submitBtn = trackContainer.querySelector('.pp_tracking_form_order .pp_tracking_button button');
        if(submitBtn) {
            submitBtn.addEventListener('click', () => fixErrorTextForInputs('.pp_tracking_form_order'));
        }

        const submitBtn2 = trackContainer.querySelector('.pp_tracking_form_number .pp_tracking_button button');
        if(submitBtn2) {
            submitBtn2.addEventListener('click', () => fixErrorTextForInputs('.pp_tracking_form_number', true));

            //Workaround to fix error messages dissapear on focus
            submitBtn2.addEventListener('keydown', (e) => {
                if(e.key === 'Enter') {
                    e.preventDefault();
                    const input = trackContainer.querySelector('.pp_tracking_form_number input');
                    input.focus();
                    input.click();
                    setTimeout(() => {
                        const alerts = trackContainer.querySelectorAll('.pp_tracking_form_number .pp_tracking_alert')
                        alerts.forEach(alert => {
                            alert.classList.add('error-cloned')
                            const id = input.getAttribute('name')+"_id";
                            alert.id = id;
                            input.setAttribute('aria-describedby', id);
                        });
                        
                    }, 100);
        
                }
            })
        }

        changeH1toDivAlert();

        const observer = new MutationObserver(() => {
            changeH1toDivAlert();
        });

        observer.observe(trackContainer, {
            subtree: true,
            childList: true
        });

        function changeH1toDivAlert() {
            const notFoundText = document.querySelector('h1.pp_tracking_result_title');
            if(!notFoundText) return;
            const newText = document.createElement('div');
            copyAttributes(notFoundText, newText);
            newText.innerText = notFoundText.innerText;
            newText.setAttribute('role', 'alert');
            notFoundText.replaceWith(newText);
        }

        function fixErrorTextForInputs(containerID, cloneError) {
            const parents = trackContainer.querySelectorAll(containerID+' .pp_tracking_input:has(.pp_tracking_alert)');
            //Workaround to fix error messages dissapear on focus
            if(cloneError) {
                const input = document.querySelector('.PP-TextField__Input[name="nums"]');
                if(input.value !== '') {
                    const error = document.querySelector('.error-cloned');
                    if(error) {
                        error.remove();
                        return;
                    }
                }
            }

            trackContainer.querySelectorAll(containerID+' .pp_tracking_input .pp_tracking_alert').forEach((element, index) => {
                if(!parents[index]) return;
                const input = parents[index].querySelector('input');
                const id = input.getAttribute('name')+"_id";
                element.id = id;

                //Workaround to fix error messages dissapear on focus
                if(cloneError && !document.querySelector('.error-cloned')) {
                    const clone = element.cloneNode(true);
                    clone.classList.add('error-cloned');
                    element.after(clone);
                }
                
                input.setAttribute('aria-describedby', id);
                if(index === 0) {
                    input.focus();
                }
            });
        }
    }

    fixTrackingPage();

    function fixProductsFilter() {
        const observer = new MutationObserver(() => {
            const filterContent = document.querySelector('.boost-sd__filter-tree-vertical-content');
        
            if(!filterContent) return;

            filterContent.querySelectorAll('.boost-sd__filter-option-range-slider-input').forEach((input, index) => {
                if(index === 0) {
                    input.setAttribute('aria-label', 'Minimun price');
                } else {
                    input.setAttribute('aria-label', 'Maximun price');
                }
            });

            const list = filterContent.querySelector('.boost-sd__filter-tree-vertical-option-list');
            if (list) {
                list.setAttribute('role', 'list');
                list.querySelectorAll(':scope > .boost-sd__filter-option').forEach(item => {
                    item.setAttribute('role', 'listitem');

                    //Group semantics for checkboxes
                    const label = item.querySelector('.boost-sd__filter-option-label');
                    const wrapper = item.querySelector('.boost-sd__filter-option-itemwrapper');
                    if(label && wrapper) {
                        label.id = "label_id" + Math.random().toString(16).slice(2);
                        wrapper.setAttribute('role', 'group');
                        wrapper.setAttribute('aria-labelledby', label.id);
                    }
                });
            }

            const productList = document.querySelector('.boost-sd-layout .boost-sd__product-list');
            productList.id = 'product_list_id';
            const isMobile = window.innerWidth < 768;

            if(!isMobile) {
                const productLink = document.createElement('a');
                productLink.innerText = 'Skip to products';
                productLink.className = 'screen-reader-text skip-link edac-removed-title';
                productLink.setAttribute('href', '#' + productList.id);

                const parent = filterContent.parentNode;
                parent.prepend(productLink);
            }


            filterContent.setAttribute('role', 'region');

            setTimeout(() => {
                filterContent.querySelectorAll('.noUi-pips').forEach(element => {
                    element.setAttribute('aria-hidden', 'true');
                });
            }, 2000);

            setTimeout(() => {
                const handleLower = filterContent.querySelector('.noUi-handle.noUi-handle-lower');
                if(handleLower) {
                    handleLower.setAttribute('aria-label', 'Minimum Price');
                }

                const handleHigher = filterContent.querySelector('.noUi-handle.noUi-handle-upper');
                if(handleHigher) {
                    handleHigher.setAttribute('aria-label', 'Maximun Price');
                }
            }, 1000);


            filterContent.querySelectorAll('.boost-sd__filter-option').forEach(element => {
                const filterBtn = element.querySelector('.boost-sd__filter-option-title');
                toggleElementVisibility(filterBtn);
                const obs = new MutationObserver(muts => {
                    for (const m of muts) {
                        if (m.type !== 'attributes' || m.attributeName !== 'class') continue;
                        const filterBtnObs = element.querySelector('.boost-sd__filter-option-title');
                        toggleElementVisibility(filterBtnObs);
                    }
                });
                const collapseContainer = element.querySelector('.boost-sd__filter-option-label');
                obs.observe(collapseContainer, {
                    attributes: true,
                    attributeFilter: ['class'],
                    attributeOldValue: true,
                });

            });

            observer.disconnect();
        });

        observer.observe(document.body, {
            subtree: true,
            childList: true
        });

        function toggleElementVisibility(filterBtn) {
            const parent = filterBtn.parentNode;
            const isClosedContent = parent.classList.contains('boost-sd__filter-option-label--collapsed');
            filterBtn.setAttribute('aria-expanded', isClosedContent ? 'false': 'true');

            const grandParent = parent.parentNode;
            grandParent.querySelectorAll('ul button').forEach(element => {
                element.setAttribute('aria-hidden', isClosedContent ? 'true':'false');
                element.setAttribute('tabindex', isClosedContent ? '-1':'0');
            });

            grandParent.querySelectorAll('ul span').forEach(element => {
                element.setAttribute('aria-hidden', isClosedContent ? 'true':'false');
            });
        }
    }

    fixProductsFilter();

    function replaceLinkWithSpan(link, secondLink) {
        const newSpan = document.createElement('span');
        copyAttributes(link, newSpan);
        newSpan.removeAttribute('href');
        newSpan.removeAttribute('target');
        newSpan.style.cursor = 'pointer';
        newSpan.innerHTML = link.innerHTML;
        link.replaceWith(newSpan);
        newSpan.addEventListener('click', () => {
            secondLink.click();
        });
        return newSpan;
    }


    function copyAttributes(source, target) {
        if (!source || !target) return;

        for (let attr of source.attributes) {
            target.setAttribute(attr.name, attr.value);
        }
    }

    function fixSocialSharingAccessibility() {
        if (!window.location.pathname.includes('/blog/')) return;

        const sharingContainer = document.querySelector('.dib-sharing');
        if (!sharingContainer) return;

        sharingContainer.setAttribute('role', 'list');
        sharingContainer.setAttribute('aria-label', 'Social media');

        const shareLinks = sharingContainer.querySelectorAll('.dib-share-link');
        shareLinks.forEach(link => {
            if (link.parentElement.getAttribute('role') === 'listitem') return;

            const listItem = document.createElement('div');
            listItem.setAttribute('role', 'listitem');
            listItem.style.display = 'inline-block';

            link.parentNode.insertBefore(listItem, link);
            listItem.appendChild(link);
        });
    }

    fixSocialSharingAccessibility();

    function listSemanticsToCategories() {
        if (!window.location.pathname.includes('/blog/')) return;

        const listText = document.querySelector('.dib-no-author .dib-post-category-text');
        if(!listText) return;

        const parent = listText.parentNode;
        parent.setAttribute('role', 'presentation');

        const container = document.createElement('span');
        container.className = listText.className;
        container.setAttribute('aria-label', 'Categories');
        container.setAttribute('role', 'list');
        container.style.display = 'flex';
        container.style.gap = '5px';
        container.style.marginBottom = '-20px';

        // Move & wrap children
        const wrapLink = (a) => {
            const w = document.createElement('span');
            w.setAttribute('role', 'listitem')
            w.appendChild(a);
            container.appendChild(w);
        };
        const addSeparator = (text) => {
            const w = document.createElement('span');
            w.textContent = text;
            w.setAttribute('aria-hidden', 'true');
            w.setAttribute('role', 'presentation');
            container.appendChild(w);
        };
        // Iterate original nodes
        Array.from(listText.childNodes).forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'A') {
                wrapLink(node);
            } else {
                const t = (node.textContent || '').trim();
                if (t) addSeparator(t);
            }
        });

        listText.replaceWith(container);

    }

    listSemanticsToCategories();
    function fixBlogImagesAltRest() {
        if (!window.location.pathname.includes('/blog')) return;

        const postContainer = document.querySelector('.dib-post-content');

        if (postContainer) {
            postContainer.querySelectorAll('img:not(.image-with-text)').forEach(img => {
                img.setAttribute('alt', '');
            });
        }

        const observer = new MutationObserver(() => {
            const postContainerIn = document.querySelector('.dib-post-content');
            if (!postContainerIn) return;

            postContainerIn.querySelectorAll('img:not(.image-with-text)').forEach(img => {
                img.setAttribute('alt', '');
            });

            observer.disconnect();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    fixBlogImagesAltRest();

    function fixBlogImagesAlt() {
      if (!window.location.pathname.includes('/blog/')) return;

          const postContainer = document.querySelector('.dib-post-single');
          if (!postContainer) return;

          const featuredImage = postContainer.querySelector('.dib-post-featured-image img');
          if (featuredImage) {
            const parent = featuredImage.parentNode;
            parent.setAttribute('aria-hidden', 'true');
            const alt = featuredImage.getAttribute('alt');
            const isAltActive = alt ? alt.endsWith("..") : false;
            if(!isAltActive) {
                featuredImage.setAttribute('alt', '');
            }
            
          }
    }

    fixBlogImagesAlt();

  function fixAudioPlayerAriaLabel() {
        if (!window.location.pathname.includes('/blog/')) return;

        const observer = new MutationObserver(() => {
            const playPauseButton = document.querySelector('.dib-audio-play-pause');
            const audioElement = document.getElementById('dib-audio-element');

            if (!playPauseButton || !audioElement) return;

            playPauseButton.setAttribute('aria-label', 'Play');

            audioElement.addEventListener('play', () => {
                playPauseButton.setAttribute('aria-label', 'Pause');
            });

            audioElement.addEventListener('pause', () => {
                playPauseButton.setAttribute('aria-label', 'Play');
            });

            audioElement.addEventListener('ended', () => {
                playPauseButton.setAttribute('aria-label', 'Play');
            });

            observer.disconnect();
        });

        const audioContainer = document.getElementById('dib-audio');
        if (!audioContainer) return;

        observer.observe(audioContainer, {
            childList: true,
            subtree: true
        });
    }

    fixAudioPlayerAriaLabel();

    function fixAudioPlayerContainerAttributes() {
        if (!window.location.pathname.includes('/blog/')) return;

        const audioContainer = document.getElementById('dib-audio');
        if (!audioContainer) return;

        const applyAttributes = () => {
            audioContainer.setAttribute('role', 'region');
            audioContainer.setAttribute('aria-label', 'Listen to article');
            return true;
        };

        if (applyAttributes()) {
            return;
        }

        const observer = new MutationObserver(() => {
            if (applyAttributes()) {
                observer.disconnect();
            }
        });

        observer.observe(audioContainer, {
            childList: true,
            subtree: true
        });
    }

    fixAudioPlayerContainerAttributes();

    function fixAudioTimeToggleAriaLabel() {
        if (!window.location.pathname.includes('/blog/')) return;

        const applyFix = () => {
            const button = document.querySelector('.dib-audio-time-remaining');
            const audio = document.getElementById('dib-audio-element');

            if (!button || !audio) {
                return false;
            }

            if (button.dataset.timeLabelEnhanced === 'true') {
                return true;
            }

            button.dataset.timeLabelEnhanced = 'true';

            let showingRemaining = true;

            const updateLabel = () => {
                const timeValue = (button.textContent || '').trim();

                const label = showingRemaining
                    ? `Time remaining ${timeValue}. Click to switch to elapsed time.`
                    : `Time elapsed ${timeValue}. Click to switch to time remaining.`;

                button.setAttribute('aria-label', label);
            };

            updateLabel();

            audio.addEventListener('timeupdate', updateLabel);
            audio.addEventListener('loadedmetadata', updateLabel);

            button.addEventListener('click', () => {
                showingRemaining = !showingRemaining;
                updateLabel();
            });

            return true;
        };

        if (applyFix()) {
            return;
        }

        const audioContainer = document.getElementById('dib-audio');
        if (!audioContainer) return;

        const observer = new MutationObserver(() => {
            if (applyFix()) {
                observer.disconnect();
            }
        });

        observer.observe(audioContainer, {
            childList: true,
            subtree: true
        });
    }

    fixAudioTimeToggleAriaLabel();


    // function fixAudioPlayerSection() {
    //     if (!window.location.pathname.includes('/blog/')) return;

    //     const observer = new MutationObserver(() => {
    //         const audioDiv = document.getElementById('dib-audio');

    //         if (!audioDiv) return;

    //         const audioSection = document.createElement('section');
    //         copyAttributes(audioDiv, audioSection);
    //         audioSection.innerHTML = audioDiv.innerHTML;
    //         audioSection.setAttribute('aria-label', 'Listen to article');

    //         audioDiv.replaceWith(audioSection);

    //         observer.disconnect();
    //     });

    //     observer.observe(document.body, {
    //         childList: true,
    //         subtree: true
    //     });
    // }

    // fixAudioPlayerSection();

    function fixAudioSpeedAriaLabel() {
        if (!window.location.pathname.includes('/blog/')) return;

        const observer = new MutationObserver(() => {
            const speedButton = document.querySelector('.dib-audio-speed');

            if (!speedButton) return;

            const currentSpeed = speedButton.textContent;
            speedButton.setAttribute('aria-label', `Audio Speed: ${currentSpeed}`);

            const textObserver = new MutationObserver(() => {
                const speed = speedButton.textContent;
                speedButton.setAttribute('aria-label', `Audio Speed: ${speed}`);
            });

            textObserver.observe(speedButton, {
                childList: true,
                characterData: true,
                subtree: true
            });

            observer.disconnect();
        });

        const audioContainer = document.getElementById('dib-audio');
        if (!audioContainer) return;

        observer.observe(audioContainer, {
            childList: true,
            subtree: true
        });
    }

    fixAudioSpeedAriaLabel();

    function fixAudioDisclaimerNotice() {
        if (!window.location.pathname.includes('/blog/')) return;

        const applyAttributes = () => {
            const infoLink = document.querySelector('.dib-audio-disclaimer svg');
            if (!infoLink) return false;
            infoLink.setAttribute('role', 'button');
            infoLink.setAttribute('tabindex', '0');
            infoLink.setAttribute('aria-label', 'Show Audio information');

            const parent = infoLink.parentNode;
            const span = parent.querySelector('span');
            span.setAttribute('aria-hidden', 'true');

            const link = parent.querySelector('a');
            link.tabIndex = '-1';
            const invisibleAlert = document.querySelector('#invisible-alert');

            const toggle = (infoLink) => {
                parent.classList.toggle('toggle-infor-audio');
                if (parent.classList.contains('toggle-infor-audio')) {
                    span.setAttribute('aria-hidden', 'false')
                    link.removeAttribute('tabindex');
                    invisibleAlert.removeAttribute('aria-hidden');
                    setTimeout(() => {
                        invisibleAlert.innerText = span.innerText;
                    }, 300)
                    infoLink.setAttribute('aria-label', 'Hide Audio information');
                } else {
                    span.setAttribute('aria-hidden', 'true')
                    link.setAttribute('tabindex', '-1');
                    infoLink.setAttribute('aria-label', 'Show Audio information');
                    invisibleAlert.innerText = '';
                    invisibleAlert.setAttribute('aria-hidden', 'true');
                }
            };

            infoLink.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === 'Escape') toggle(infoLink);
            });

            infoLink.addEventListener('click', () => toggle(infoLink));

            return true;
        };

        if (applyAttributes()) {
            return;
        }

        const audioContainer = document.getElementById('dib-audio');
        if (!audioContainer) return;

        const observer = new MutationObserver(() => {
            if (applyAttributes()) {
                observer.disconnect();
            }
        });

        observer.observe(audioContainer, {
            childList: true,
            subtree: true
        });
    }

    fixAudioDisclaimerNotice();

    function enableAudioProgressKeyboard() {
        if (!window.location.pathname.includes('/blog/')) return;

        const container = document.querySelector('.dib-audio-progress-container');
        if (!container) return;

        const applyEnhancements = () => {
            const dragHandle = container ? container.querySelector('.dib-audio-drag-handle') : null;
            const audio = document.getElementById('dib-audio-element');

            if (!container || !dragHandle || !audio) {
                return false;
            }

            if (dragHandle.dataset.keyboardEnhanced === 'true') {
                return true;
            }

            dragHandle.dataset.keyboardEnhanced = 'true';
            dragHandle.setAttribute('tabindex', '0');
            dragHandle.setAttribute('role', 'slider');
            dragHandle.setAttribute('aria-valuemin', '0:00');

            const getStep = () => {
                const duration = isFinite(audio.duration) && audio.duration > 0 ? audio.duration : 0;
                return duration > 0 ? Math.max(duration / 100, 1) : 5;
            };

            const clampTime = (time) => {
                if (isFinite(audio.duration) && audio.duration > 0) {
                    return Math.min(Math.max(time, 0), audio.duration);
                }
                return Math.max(time, 0);
            };

            const formatSeconds = (seconds) => {
                if (!isFinite(seconds) || seconds <= 0) return '0:00';
                const mins = Math.floor(seconds / 60);
                const secs = Math.floor(seconds % 60);
                return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
            };

            const updateSliderAria = () => {
                const timeButton = document.querySelector('.dib-audio-time-remaining');
                const timeText = timeButton && timeButton.textContent
                    ? timeButton.textContent.trim()
                    : '0:00';

                dragHandle.setAttribute('aria-valuenow', timeText);
                dragHandle.setAttribute('aria-valuetext', timeText);
                if (audio.duration && isFinite(audio.duration)) {
                    dragHandle.setAttribute('aria-valuemax', formatSeconds(audio.duration));
                }
            };

            updateSliderAria();

            audio.addEventListener('timeupdate', updateSliderAria);
            audio.addEventListener('loadedmetadata', updateSliderAria);

            dragHandle.addEventListener('keydown', (event) => {
                const step = getStep();
                let handled = false;

                if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
                    audio.currentTime = clampTime(audio.currentTime + step);
                    handled = true;
                } else if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
                    audio.currentTime = clampTime(audio.currentTime - step);
                    handled = true;
                }

                if (handled) {
                    updateSliderAria();
                    event.preventDefault();
                    event.stopPropagation();
                }
            });

            return true;
        };

        if (applyEnhancements()) {
            return;
        }

        const observer = new MutationObserver(() => {
            if (applyEnhancements()) {
                observer.disconnect();
            }
        });

        observer.observe(container, {
            childList: true,
            subtree: true
        });
    }

    enableAudioProgressKeyboard();

    function fixRelatedArticlesList() {
        if (!window.location.pathname.includes('/blog/')) return;

        const applyFix = () => {
            const containers = document.querySelectorAll('.dib-related-posts');
            if (!containers.length) {
                return false;
            }

            containers.forEach((container) => {
                container.setAttribute('role', 'list');

                const applyItemsRole = () => {
                    const items = container.querySelectorAll('.dib-related-post');
                    items.forEach((item) => {
                        if (!item.hasAttribute('role')) {
                            item.setAttribute('role', 'listitem');
                        }

                        const title = item.querySelector('h2');
                        if (title) {
                            const heading = document.createElement('div');
                            heading.className = title.className;
                            heading.innerHTML = title.innerHTML;
                            title.replaceWith(heading);
                        }

                        const imageLink = item.querySelector('.dib-post-featured-image a');
                        const titleLink = item.querySelector('.dib-post-title-link');
                        if (imageLink && titleLink) {
                            const parent = imageLink.closest('.dib-post-featured-image');
                            if(parent) {
                                parent.setAttribute('aria-hidden', 'true');
                            }
                            const newlink = replaceLinkWithSpan(imageLink, titleLink);
                            newlink.querySelector('img').setAttribute('alt', '');
                        }
                    });
                };

                applyItemsRole();
            });

            return true;
        };

        if (applyFix()) {
            return;
        }

        const container = document.querySelector('.dib-related-posts');
        if (!container) return;

        const observer = new MutationObserver(() => {
            if (applyFix()) {
                observer.disconnect();
            }
        });

        observer.observe(container, {
            childList: true,
            subtree: true
        });
    }

    fixRelatedArticlesList();

    function fixFaqAccessibility() {
        if (!window.location.pathname.includes('/blog/')) return;
        
        const faqId = document.querySelector('#faqs-5');
        if (!faqId) return;

        const applyFix = () => {
            const faqItems = document.querySelectorAll('.dib-faq .dib-faq-item');
            if (!faqItems.length) {
                return false;
            }

            let faqPanelIdCounter = 0;

            faqItems.forEach((item) => {
                const content = item.querySelector('.dib-faq-item-content');
                if (!content) return;

                if (!content.id) {
                    faqPanelIdCounter += 1;
                    content.id = `faq_panel_${faqPanelIdCounter}`;
                }

                const updateHidden = () => {
                    const isOpen = item.hasAttribute('open');
                    content.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
                };

                updateHidden();

                if (!item.dataset.faqEnhanced) {
                    item.addEventListener('toggle', updateHidden);
                    item.dataset.faqEnhanced = 'true';
                }
            });

            return true;
        };

        if (applyFix()) {
            return;
        }

        const faqContainer = document.querySelector('.dib-faq');
        if (!faqContainer) return;

        const observer = new MutationObserver(() => {
            if (applyFix()) {
                observer.disconnect();
            }
        });

        observer.observe(faqContainer, {
            childList: true,
            subtree: true
        });
    }

    fixFaqAccessibility();

    function fixSocialMediaRolesBlog() {
         if (!window.location.pathname.includes('/blog/')) return;

        document.querySelectorAll('.social-media-links').forEach(wrapper => {
            wrapper.setAttribute('role', 'list');
            const items = wrapper.querySelectorAll('p');
            items.forEach(item => {
                if(item.innerText.trim().length > 0) {
                    item.setAttribute('role', 'listitem');
                }
                
            });
            const title = wrapper.previousElementSibling;
            if(title && title.tagName === 'P' && (title.innerText.toLowerCase().includes('Connect with us'.toLowerCase()) || title.innerText.toLowerCase().includes('Contact us'.toLowerCase()))) {
                const newTitle = document.createElement('h2');
                newTitle.classList.add('title-normal');
                newTitle.innerHTML = title.innerHTML;
                title.replaceWith(newTitle);
            }
        });

        document.querySelectorAll('.list').forEach(wrapper => {
            wrapper.setAttribute('role', 'list');
            const items = wrapper.querySelectorAll('.child-item');
            items.forEach(item => {
                item.setAttribute('role', 'listitem');
            });

            const title = wrapper.previousElementSibling;
            if(title && title.tagName === 'P' && (title.innerText.toLowerCase().includes('Connect with us'.toLowerCase()) || title.innerText.toLowerCase().includes('Contact us'.toLowerCase()))) {
                const newTitle = document.createElement('h2');
                newTitle.classList.add('title-normal');
                newTitle.innerHTML = title.innerHTML;
                title.replaceWith(newTitle);
            }
        });
    }

    fixSocialMediaRolesBlog();


    function fixProductSelectLabels() {
        
        if (!window.location.pathname.includes('/blog/')) return;

        const addLabelsToSelects = () => {
            
            const missingLabelContainers = document.querySelectorAll('.missing-label-select');
            
            if (missingLabelContainers.length === 0) return;

        
            missingLabelContainers.forEach(container => {
            
                const productVariantsDiv = container.querySelector('#product-variants');
                if (!productVariantsDiv) return;

            
                const select = productVariantsDiv.querySelector('select');
                if (!select) return;

                
                const selectId = select.id;
                const existingLabel = productVariantsDiv.querySelector(`label[for="${selectId}"]`);
                if (existingLabel) return;

                
                const label = document.createElement('label');
                label.htmlFor = selectId; 
                label.className = 'visually-hidden'; 
                label.textContent = 'Select product option'; 
            
                select.parentNode.insertBefore(label, select);
            });
        };


        addLabelsToSelects();

        const missingLabelContainers = document.querySelectorAll('.missing-label-select');
        if (missingLabelContainers.length === 0) return;

        const observer = new MutationObserver(addLabelsToSelects);
            
        missingLabelContainers.forEach(container => {
            observer.observe(container, {
                    childList: true,
                    subtree: true
            });
        });
    }


    fixProductSelectLabels();

    function fixFlickityDots(container) {
        const dotsList = container.querySelector('.flickity-page-dots');

        if(dotsList) {
            dotsList.setAttribute('role', 'none');
            const dots = dotsList.querySelectorAll('.dot');
            dots.forEach((dot, index) => {
                dot.setAttribute('tabindex', '0');
                dot.setAttribute('role', 'button');
                dot.setAttribute('aria-label', `Slide ${index+1} of ${dots.length} `);
            })

            return dots;
        }

        return [];
    }

    function quickViewListener(quickViewBtn) {
        if(!quickViewBtn || (quickViewBtn && !quickViewBtn.classList.contains('nt_add_qv'))) return;
        
        quickViewBtn.addEventListener('click', () => {
            const observer = new MutationObserver(() => {
                const container = document.querySelector('.mfp-ready .mfp-content');
                if(!container) return;
                container.querySelectorAll('.flickity-button, .product-images-slider, .jdgm-prev-badge__stars').forEach(element => {
                    if(!element.classList.contains('jdgm-prev-badge__stars')) {
                        element.setAttribute('aria-hidden', 'true');
                    }
                    
                    element.setAttribute('tabindex', '-1');
                });

                const linkReview = container.querySelector('.rating_sp_kl');
                if(linkReview) {
                    linkReview.setAttribute('tabindex', '-1');
                    linkReview.setAttribute('aria-hidden', 'true');
                }

                // fixFlickityDots(container);
                trapFocus(container, quickViewBtn);

                observer.disconnect();
            });

            observer.observe(document.body, {
                subtree: true,
                childList: true
            });
        })
    }

    function removeTabindexFromSliderContainer() {
        setTimeout(() => {
            document.querySelectorAll('.slideshow, .nt_banner_holder').forEach(slideShow => {
                slideShow.removeAttribute('tabindex');
            });
        }, 1000);
    }

    removeTabindexFromSliderContainer();

    // function fixShopTheLook() {
    //     const container = document.querySelector('.evm_lookbook_block');
    //     if(!container) return;

    //     const observer = new MutationObserver(() => {
    //         const list = container.querySelector('.EVMLookbookgrid');
    //         if(!list) return;
    //         list.querySelectorAll('.evmhash').forEach((element, index) => {
    //             element.setAttribute('aria-label', `Customer's space ${index + 1}`);
    //             element.addEventListener('click', () => {
    //                 setTimeout(() => fixModal(element), 500);
    //             });
    //         });
    //         list.querySelectorAll('.evmhash a').forEach(element => {
    //             element.setAttribute('tabindex', '-1');
    //             element.setAttribute('aria-hidden', 'true');
    //         });
    //         observer.disconnect();
    //     });

    //     observer.observe(container, {
    //         subtree: true,
    //         childList: true
    //     });

    //     function fixModal(btn) {
    //         const modal = document.querySelector('.evm_fancybox-overlay');
    //         if(!modal) return;

    //         const focusableElements = modal.querySelectorAll('.evm_fancybox-skin .evm_fancybox-close, .evm_fancybox-skin .evm_fancybox-nav, .evm_fancybox-skin .evm_fancybox-outer .evm-list .evm_tag_view > a');
    //         modal.querySelectorAll('.evm_fancybox-skin .evm_fancybox-close, .evm_fancybox-skin .evm_fancybox-nav').forEach(element => {
    //             element.setAttribute('aria-label', element.getAttribute('title'));
    //             element.removeAttribute('title');
    //         });
    //         trapFocus(modal, btn, focusableElements);

    //         focusableElements.forEach(element => {
    //             const popup = element.nextElementSibling;
    //             if(popup && popup.classList.contains('evm_lookbook_detail')) {
    //                 const title = popup.querySelector('.evm_look_book_title');
    //                 if(title) {
    //                     element.setAttribute('aria-label', `Open modal for: ${title.innerText}. Close modal with scape.`);
    //                 }
                    
    //                 handleEnterKeyAndEscapeKey(element, popup);
    //                 handleClickEventAndKeydown(element, popup);
    //             }
    //         });

    //         const observer = new MutationObserver(() => {
    //             const innerWrap = modal.querySelector('.evm_fancybox-wrap');
    //             if(!innerWrap) return;

    //             setTimeout(() => {
    //                 fixModal(btn);
    //             }, 500)

    //             observer.disconnect();
    //         });

    //         observer.observe(modal, {
    //             subtree: true,
    //             childList: true
    //         });
    //     }

    //     function handleEnterKeyAndEscapeKey(btn, popup) {
    //         let onPopupKeydown;

    //         btn.addEventListener('keydown', (e) => {
    //             if (e.key !== 'Enter' || e.repeat) return;

    //             e.preventDefault();
    //             e.stopPropagation();

    //             popup.classList.toggle('toggleModal');
    //             trapFocus(popup, btn);

    //             if (onPopupKeydown) {
    //                 popup.removeEventListener('keydown', onPopupKeydown, true); // capture flag must match
    //             }

                
    //             onPopupKeydown = function(ev) {
    //                 if (ev.key === 'Escape') {
    //                     ev.preventDefault();
    //                     ev.stopPropagation();
    //                     popup.classList.toggle('toggleModal'); // close inner
    //                     popup.removeEventListener('keydown', onPopupKeydown, true);
    //                     onPopupKeydown = null;
    //                     btn.focus();
    //                 }
    //             };
    //             popup.addEventListener('keydown', onPopupKeydown, { capture: true });
    //         }, { capture: true });

    //         btn.addEventListener('keydown', (e) => {

    //         })
    //     }

    //     function handleClickEventAndKeydown(btn, popup) {
    //         let onPopupKeydown;
    //         btn.addEventListener('click', () => {
    //                 popup.classList.toggle('toggleModal');
    //                 if(popup.classList.contains('toggleModal')) {
    //                     trapFocus(popup, btn);
    //                     if (onPopupKeydown) {
    //                         popup.removeEventListener('keydown', onPopupKeydown, true);
    //                     }

    //                     onPopupKeydown = function(ev) {
    //                         if (ev.key === 'Escape') {
    //                             ev.preventDefault();
    //                             ev.stopPropagation();
    //                             popup.classList.toggle('toggleModal');
    //                             popup.removeEventListener('keydown', onPopupKeydown, true);
    //                             onPopupKeydown = null;
    //                             btn.focus();
    //                         }
    //                     };
    //                     popup.addEventListener('keydown', onPopupKeydown, { capture: true });
    //                 }
    //         });
    //     }
    // }

    // fixShopTheLook();
        function fixShopTheLook() {
        const container = document.querySelector('.evm_lookbook_block');
        if (!container) return;

        const slideshow = document.querySelector('.slideshow');

        if (slideshow) {
            slideshow.removeAttribute('tabindex');
        }
        let currentIndex = 1;
        const observer = new MutationObserver(() => {
            const list = container.querySelector('.EVMLookbookgrid');
            if (!list) return;
            list.querySelectorAll('.evmhash').forEach((element, index) => {
                element.style.cursor = 'pointer';
                element.setAttribute('aria-label', `Customer's space ${currentIndex}`);
                element.addEventListener('click', () => {
                    setTimeout(() => fixModal(), 1000);
                });
                currentIndex++;
                observeLI(element.closest('li'));
            });
            list.querySelectorAll('.evmhash .evm-list a').forEach(element => {
                element.style.cursor = 'pointer';
                element.removeAttribute('href');
                element.setAttribute('tabindex', '-1');
                element.setAttribute('aria-hidden', 'true');
            });

            document.querySelectorAll('.evm_lookbook_detail').forEach(popup => {
                const links = popup.querySelectorAll('.evm_shop_now_container a, .evm_lookbook_detail_content a');
                if (links.length > 1) {
                    replaceLinkWithSpan(links[0], links[1]);
                }
            });

            const observerUL = new MutationObserver((mutations) => {
                mutations.forEach(mutation => {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeName === 'LI') {
                            const items = node.querySelectorAll('a');
                            observeLI(node);
                            if (items.length) {
                                items.forEach((innerLink, index) => {
                                    if (index === 0) {
                                        innerLink.setAttribute('aria-label', `Customer's space ${currentIndex}`);
                                        innerLink.style.cursor = 'pointer';
                                        innerLink.addEventListener('click', () => {
                                            setTimeout(() => fixModal(), 1000);
                                        });
                                    } else {
                                        innerLink.style.cursor = 'pointer';
                                        innerLink.removeAttribute('href');
                                        innerLink.setAttribute('tabindex', '-1');
                                        innerLink.setAttribute('aria-hidden', 'true');
                                    }
                                });
                            } else {
                                node.querySelector('img').setAttribute('alt', `Customer's space ${currentIndex}`)
                            }
                            currentIndex++;
                        }
                    });
                });
            });

            observerUL.observe(list, {
                childList: true
            });


            observer.disconnect();
        });

        observer.observe(container, {
            subtree: true,
            childList: true
        });

        function observeLI(li) {
            const update = (node) => {
                if (node.getAttribute('aria-label') || node.closest('.evm_lookbook_detail')) return
                node.style.cursor = 'pointer';
                node.removeAttribute('href');
                node.setAttribute('tabindex', '-1');
                node.setAttribute('aria-hidden', 'true');
            };
            const observerLI = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1 && node.tagName === "A") update(node);
                        if (node.nodeType === 1) {
                            const links = node.querySelectorAll("a");
                            links.forEach(link => update(link));
                        }
                    });
                });
            });
            observerLI.observe(li, { childList: true, subtree: true });
        }

        function fixModal() {
            const modal = document.querySelector('.evm_fancybox-overlay:has(a), .evm_fancybox-opened:has(a)');
            if (!modal) return;
            modal.querySelectorAll('.evm_tag_view a').forEach(link => {
                link.removeAttribute('aria-hidden');
                link.setAttribute('tabindex', '0')
            })
            modal.setAttribute('role', 'dialog');
            const classId = modal.querySelector('.evm_tag_view');
            const id = classId.id.split('_').pop();
            const elementID = document.getElementById(id);
            modal.setAttribute('aria-label', elementID.getAttribute('aria-label'));

            const focusableElements = modal.querySelectorAll('.evm_fancybox-skin .evm_fancybox-close, .evm_fancybox-skin .evm_fancybox-nav, .evm_fancybox-skin .evm_fancybox-outer .evm-list .evm_tag_view > a');
            modal.querySelectorAll('.evm_fancybox-skin .evm_fancybox-close, .evm_fancybox-skin .evm_fancybox-nav').forEach(element => {
                element.setAttribute('aria-label', element.getAttribute('title'));
                element.removeAttribute('title');
            });

            trapFocus(modal, elementID, focusableElements);
            fixModalControls(modal, elementID);

            focusableElements.forEach(element => {
                const popup = element.nextElementSibling;
                if (popup && popup.classList.contains('evm_lookbook_detail')) {
                    const title = popup.querySelector('.evm_look_book_title');
                    if (title) {
                        element.setAttribute('aria-label', `Open ${title.innerText} modal`);
                    }
                    popup.setAttribute('role', 'dialog');
                    popup.setAttribute('aria-modal', 'true');
                    handleEnterKeyAndEscapeKey(element, popup);
                    handleClickEventAndKeydown(element, popup);
                }
            });

            const observer = new MutationObserver(() => {
                const innerWrap = modal.querySelector('.evm_fancybox-wrap');
                if (!innerWrap) return;

                setTimeout(() => {
                    fixModal(elementID);
                }, 500)

                observer.disconnect();
            });

            observer.observe(modal, {
                subtree: true,
                childList: true
            });
        }

        function handleEnterKeyAndEscapeKey(btn, popup) {
            btn.addEventListener('keydown', (e) => {
                if (e.key !== 'Enter' || e.repeat) return;
                let onPopupKeydown;

                e.preventDefault();
                e.stopPropagation();

                popup.classList.toggle('toggleModal');
                trapFocus(popup, btn);

                if (onPopupKeydown) {
                    popup.removeEventListener('keydown', onPopupKeydown, true); // capture flag must match
                }


                onPopupKeydown = function (ev) {
                    if (ev.key === 'Escape') {
                        ev.preventDefault();
                        ev.stopPropagation();
                        popup.classList.toggle('toggleModal'); // close inner
                        popup.removeEventListener('keydown', onPopupKeydown, true);
                        onPopupKeydown = null;
                        btn.focus();
                    }
                };
                popup.addEventListener('keydown', onPopupKeydown, { capture: true });
            }, { capture: true });
        }

        function handleClickEventAndKeydown(btn, popup) {
            let onPopupKeydown;
            btn.addEventListener('click', () => {
                popup.classList.toggle('toggleModal');
                if (popup.classList.contains('toggleModal')) {
                    trapFocus(popup, btn);
                    if (onPopupKeydown) {
                        popup.removeEventListener('keydown', onPopupKeydown, true);
                    }

                    onPopupKeydown = function (ev) {
                        if (ev.key === 'Escape') {
                            ev.preventDefault();
                            ev.stopPropagation();
                            popup.classList.toggle('toggleModal');
                            popup.removeEventListener('keydown', onPopupKeydown, true);
                            onPopupKeydown = null;
                            btn.focus();
                        }
                    };
                    popup.addEventListener('keydown', onPopupKeydown, { capture: true });
                }
            });
        }

        function fixModalControls(modal, btn) {
            const closeButton = modal.querySelector('.evm_fancybox-close');
            fixModalControlActivation(closeButton, 'evmKbClose', btn);

            modal.querySelectorAll('.evm_fancybox-nav').forEach(navBtn => {
                fixModalControlActivation(navBtn, navBtn.classList.contains('evm_fancybox-prev') ? 'evmKbPrev' : 'evmKbNext');
            });
        }

        function fixModalControlActivation(element, flag, btn) {
            if (!element || element.dataset[flag]) return;
            element.dataset[flag] = 'true';

            element.setAttribute('role', element.getAttribute('role') || 'button');
            element.addEventListener('click', () => {
                if(btn) {
                    btn.focus();
                }
            });
            element.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    event.stopPropagation();
                    element.click();
                    if(btn) {
                        btn.focus();
                    }
                }
            });
        }
    }

    fixShopTheLook()

    function listSemanticsToFaqAccordion() {
        const accordionContainer = document.querySelector('.dib-faq');
        if (!accordionContainer) return;

        const newContainerList = document.createElement('div');
        newContainerList.setAttribute('role', 'list');
        const heading = accordionContainer.querySelector('.dib-faq-heading');

        if (heading) {
            const newHeading = document.createElement('div');
            copyAttributes(heading, newHeading);
            newHeading.innerText = heading.innerText;
            heading.replaceWith(newHeading);
        }

        accordionContainer.querySelectorAll('.dib-faq-item').forEach(item => {
            const newListItem = document.createElement('div');
            newListItem.setAttribute('role', 'listitem');
            newListItem.appendChild(item);
            newContainerList.appendChild(newListItem);
        });

        accordionContainer.appendChild(newContainerList);
    }

    listSemanticsToFaqAccordion();

    function findAndFixRedundantLinks() {
        const groupedLinks = groupLinksByHref();
        processLinkGroups(groupedLinks);
    }

    function groupLinksByHref() {
        const allLinks = document.querySelectorAll('.dib-post-content a');
        const urlGroups = {};

        allLinks.forEach(link => {
            const url = link.href;
            if (!urlGroups[url]) {
            urlGroups[url] = [];
            }
            urlGroups[url].push(link);
        });
        
        return urlGroups;
    }

    function processLinkGroups(groups) {
        for (const url in groups) {
            const elements = groups[url];

            if (elements.length < 2) {
            continue;
            }

            const imageLinks = [];
            const nonImageLinks = [];

            elements.forEach(link => {
            if (link.querySelector('img')) {
                imageLinks.push(link);
            } else {
                nonImageLinks.push(link);
            }
            });

            if (imageLinks.length > 0 && nonImageLinks.length > 0) {
            imageLinks.forEach(link => {
                neutralizeLink(link);
            });
            }
        }
    }

    function neutralizeLink(link) {

        const span = document.createElement('span');


        span.innerHTML = link.innerHTML;
        if (link.className) span.className = link.className;
        if (link.id) span.id = link.id;
        if (link.style.cssText) span.style.cssText = link.style.cssText;
        
        span.style.cursor = 'pointer';

        // 4. Add the click event to stop navigation
        span.addEventListener('click', (event) => {
            event.preventDefault(); 
            event.stopPropagation();
            window.location.href = link.href;
        });

        if (link.parentNode) {
            link.parentNode.replaceChild(span, link);
        }
    }

    findAndFixRedundantLinks();


function cartWidgetAccessibilityEnabl() {

    // 1 - Selection of elements
    const cartCanvas = document.getElementById('nt_cart_canvas');
    const cartLink = document.querySelector('a[data-id="#nt_cart_canvas"]');

    if (!cartCanvas || !cartLink) return;

    // 2 - State variables
    let isIsolating = false;
    let currentActiveContainer = null;
    let lastTriggerSelector = null;

    // 3 - Helper for focusable elements
    function getFocusables(container) {
        if (!container) return [];
        const selector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
        return Array.from(container.querySelectorAll(selector))
            .filter(el => !el.hasAttribute('disabled') && el.offsetParent !== null);
    }


    function silenceCartImages() {
        const imgs = cartCanvas.querySelectorAll('img');
        imgs.forEach(img => {
            img.setAttribute('alt', ''); 
            img.setAttribute('role', 'presentation');
            img.setAttribute('aria-hidden', 'true');
        });
    }

    function setSpecialButtonsState(isOpen) {
        const noteBtn = cartCanvas.querySelector('[data-id="note"]');
        const disBtn  = cartCanvas.querySelector('[data-id="dis"]');

        if (isOpen) {
            if (noteBtn) {
                noteBtn.setAttribute('tabindex', '0');
                noteBtn.setAttribute('aria-hidden', 'false');
            }
            if (disBtn) {
                disBtn.setAttribute('tabindex', '0');
                disBtn.setAttribute('aria-hidden', 'false');
            }
        } else {
            if (noteBtn) {
                noteBtn.setAttribute('tabindex', '-1');
                noteBtn.setAttribute('aria-hidden', 'true');
            }
            if (disBtn) {
                disBtn.setAttribute('tabindex', '-1');
                disBtn.setAttribute('aria-hidden', 'true');
            }
        }
    }

    // 4 - Master isolation function
    function isolateView(viewType) {
        const noteView = cartCanvas.querySelector(".mini_cart_note");
        const disView  = cartCanvas.querySelector(".mini_cart_dis");
        const mainView = cartCanvas.querySelector(".mini_cart_wrap");

        const setState = (el, active, isTool) => {
            if (!el) return;

            if (active) {
                if (isTool) el.style.display = '';
                el.removeAttribute('aria-hidden');
                el.classList.remove('pe_none');
                if (isTool) {
                    el.setAttribute('role', 'dialog');
                    el.setAttribute('aria-modal', 'true');
                }
            } else {
                if (isTool) {
                    el.style.display = 'none'; 
                    el.removeAttribute('role');
                    el.removeAttribute('aria-modal');
                } else {
                    el.setAttribute('aria-hidden', 'true');
                }
            }

            const allItems = el.querySelectorAll('a, button, input, textarea, select');
            allItems.forEach(item => {
                const isSpecialBtn = item.getAttribute('data-id') === 'note' || item.getAttribute('data-id') === 'dis';
                if (!isSpecialBtn) {
                    if (active) {
                        item.removeAttribute('tabindex'); 
                        item.setAttribute('aria-hidden', 'false');
                    } else {
                        item.setAttribute('tabindex', '-1');
                        item.setAttribute('aria-hidden', 'true');
                    }
                }
            });
        };

        if (viewType === 'note') {
            setState(mainView, false, false); 
            setState(disView, false, true); 
            setState(noteView, true, true);
            currentActiveContainer = noteView;
        } 
        else if (viewType === 'dis') {
            setState(mainView, false, false); 
            setState(noteView, false, true); 
            setState(disView, true, true);
            currentActiveContainer = disView;
        }
        else {
            mainView.removeAttribute('aria-hidden');
            setState(mainView, true, false);
            setState(noteView, false, true); 
            setState(disView, false, true); 
            currentActiveContainer = mainView;
        }
    }

    // 5 - Global keyboard listener
    cartCanvas.addEventListener('keydown', function(e) {
        if (!currentActiveContainer) return;

        const focusables = getFocusables(currentActiveContainer);
        
        if (focusables.length === 0) {
            if (e.key === "Escape") {
            } else {
                return; 
            }
        }

        const index = focusables.indexOf(document.activeElement);

        if ((e.key === "Tab" && e.shiftKey) || e.key === "ArrowLeft") {
            if (index !== -1) {
                e.preventDefault();
                if (index > 0) {
                    focusables[index - 1].focus();
                } else {
                    focusables[focusables.length - 1].focus();
                }
            }
        }
        else if ((e.key === "Tab" && !e.shiftKey) || e.key === "ArrowRight") {
            if (index !== -1) {
                e.preventDefault(); 
                if (index < focusables.length - 1) {
                    focusables[index + 1].focus(); 
                } else {
                    focusables[0].focus(); 
                }
            }
        }
        
        if (e.key === "Escape") {
            const mainWrapper = cartCanvas.querySelector(".mini_cart_wrap");
            if (currentActiveContainer && currentActiveContainer !== mainWrapper) {
                e.preventDefault();
                e.stopImmediatePropagation();
                const backBtn = currentActiveContainer.querySelector('.js_cart_tls_back');
                if (backBtn) backBtn.click();
                else {
                    isolateView('main');
                    setSpecialButtonsState(true);
                    restoreFocus();
                }
            } else {
                closeCart(); 
                cartLink.focus();
            }
        }
    });

    cartCanvas.addEventListener('keyup', function(e) {
        if (e.key === "Escape") {
            const mainWrapper = cartCanvas.querySelector(".mini_cart_wrap");
            if (currentActiveContainer && currentActiveContainer !== mainWrapper) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        }
    });

    // 6 - OPEN CART Function
    function openCart() {
        cartCanvas.classList.add('current_hover');
        cartCanvas.setAttribute('aria-modal', 'true');
        cartCanvas.setAttribute('role', 'dialog');
        cartCanvas.removeAttribute('aria-hidden'); 
        
        isolateView('main');
        silenceCartImages();
        setSpecialButtonsState(true);

        setTimeout(() => {
            const noteBtn = cartCanvas.querySelector('[data-id="note"]');
            const disBtn  = cartCanvas.querySelector('[data-id="dis"]');

            if (noteBtn && noteBtn.offsetParent !== null) {
                noteBtn.focus();
            } else if (disBtn && disBtn.offsetParent !== null) {
                disBtn.focus();
            } else {
                const focusables = getFocusables(cartCanvas.querySelector(".mini_cart_wrap"));
                if (focusables.length > 0) focusables[0].focus();
            }
        }, 100);
    }

    // 7 - CLOSE CART Function
    function closeCart() {
        cartCanvas.classList.remove('current_hover');
        cartCanvas.removeAttribute('role');
        cartCanvas.removeAttribute('aria-modal');
        cartCanvas.setAttribute('aria-hidden', 'true');

        const allFocusables = cartCanvas.querySelectorAll('a, button, input, textarea, select, [tabindex]');
        allFocusables.forEach(el => {
            el.setAttribute('tabindex', '-1');
            el.setAttribute('aria-hidden', 'true');
        });

        setSpecialButtonsState(false);
        currentActiveContainer = null;
    }

    cartLink.addEventListener('click', e => {
        e.preventDefault();
        openCart();
    });

    cartLink.addEventListener('keydown', e => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault(); 
            e.currentTarget.click(); 
        }
    });

    // 8 - General Observer
    const observer = new MutationObserver(() => {
        if (cartCanvas.classList.contains('current_hover')) {
            if (!currentActiveContainer) {
                isolateView('main');
                setSpecialButtonsState(true);
            }
        } else {
            if (currentActiveContainer) { 
                closeCart();
            }
        }
    });
    observer.observe(cartCanvas, { attributes: true, attributeFilter: ['class'] });

    function restoreFocus() {
        if (lastTriggerSelector) {
            const btn = cartCanvas.querySelector(lastTriggerSelector);
            if (btn) {
                btn.setAttribute('tabindex', '0');
                btn.focus();
            }
        }
    }

    // 9 - Tools
    function enableToolTriggers() {
        const noteBtn = cartCanvas.querySelector('[data-id="note"]');
        const disBtn  = cartCanvas.querySelector('[data-id="dis"]');
        
        const activateTool = (toolName, selector) => {
            lastTriggerSelector = selector;
            isolateView(toolName);
            setTimeout(() => {
                if (!currentActiveContainer) return;
                const items = getFocusables(currentActiveContainer);
                if (items.length > 0) items[0].focus();
            }, 150);
        };

        if (noteBtn) {
            noteBtn.addEventListener('click', () => activateTool('note', '[data-id="note"]'));
            noteBtn.addEventListener('keydown', e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); noteBtn.click(); } });
        }
        if (disBtn) {
            disBtn.addEventListener('click', () => activateTool('dis', '[data-id="dis"]'));
            disBtn.addEventListener('keydown', e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); disBtn.click(); } });
        }
        
        const backButtons = cartCanvas.querySelectorAll('.js_cart_tls_back');
        backButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                setTimeout(() => {
                    isolateView('main');
                    setSpecialButtonsState(true);
                    restoreFocus();
                }, 100);
            });
        });
    }

    enableToolTriggers();

    const innerViewObserver = new MutationObserver((mutations) => {
        if (!cartCanvas.classList.contains('current_hover')) return;

        let domChanged = false;
        mutations.forEach(m => {
            if (m.type === 'childList' && m.removedNodes.length > 0) domChanged = true;
        });

        if (domChanged) {
            setTimeout(() => {
                isolateView('main'); 
                setSpecialButtonsState(true);
                silenceCartImages();

                const focusLost = document.activeElement === document.body;
                
                if (focusLost) {
                    const focusables = getFocusables(cartCanvas.querySelector(".mini_cart_wrap"));
                    if (focusables.length > 0) {
                        focusables[0].focus();
                    } else {
                        const noteBtn = cartCanvas.querySelector('[data-id="note"]');
                        if (noteBtn) noteBtn.focus();
                    }
                }
            }, 150);
        }
    });
    
    innerViewObserver.observe(cartCanvas, { childList: true, subtree: true });

    // 10 - Empty Cart handling
    function handleEmptyCartFocus() {
        const emptyBox = cartCanvas.querySelector('.empty');
        if (!emptyBox) return;

        if (!cartCanvas.classList.contains('current_hover')) return;

        const isVisible = emptyBox.style.display === 'block' || !emptyBox.classList.contains('dn');
        if (!isVisible) return;

        const allFocusable = cartCanvas.querySelectorAll('a, button, input, textarea, select, [tabindex]');
        allFocusable.forEach(el => {
            el.setAttribute('tabindex', '-1');
            el.setAttribute('aria-hidden', 'true');
        });

        const returnBtn = emptyBox.querySelector('a.button_primary');
        if (returnBtn) {
            returnBtn.removeAttribute('tabindex');
            returnBtn.setAttribute('aria-hidden', 'false');

            setTimeout(() => {
                returnBtn.focus();
                currentActiveContainer = emptyBox;
            }, 120);
        }
    }

    const emptyObserver = new MutationObserver(() => handleEmptyCartFocus());
    emptyObserver.observe(cartCanvas, { childList: true, subtree: true });

    closeCart(); 
}

cartWidgetAccessibilityEnabl();

    function listenToQuickViewCollection() {
        document.addEventListener('click', (e) => {
        const btn = e.target.closest('.boost-sd__btn-quick-view');
        if (!btn) return;

        setTimeout(() => {
            const modal = document.querySelector('.boost-sd__modal');
            if(!modal) return
            
            const title = modal.querySelector('.boost-sd__quick-view-title');
            if(title) {
                const h1 = document.createElement('h1');
                h1.innerText = title.innerText;
                h1.className = title.className;
                h1.id = "boost_modal_id";
                title.replaceWith(h1);
                modal.setAttribute('aria-labelledby', 'boost_modal_id');
                modal.removeAttribute('aria-label');

                const qtyContainer = modal.querySelector('.boost-sd__quick-view-quantity');
                if(qtyContainer) {
                    qtyContainer.querySelectorAll('.boost-sd__button--as-quantity').forEach((btnQty, index) => {
                        const label = index === 0 ? 'Decrease quantity' : 'Increase quantity';
                        btnQty.setAttribute('aria-label', label);
                        btnQty.setAttribute('aria-describedby', h1.id);
                    });
                }

                modal.querySelectorAll('.boost-sd__quick-view-btn button, .boost-sd__quick-view-details-link').forEach(btnQuick => {
                    btnQuick.setAttribute('aria-describedby', h1.id);
                });
            }

            //RADIO SEMANTICS
            const group = modal.querySelector('.boost-sd__product-swatch-options');
            if (group && !group.getAttribute('applied')) {
                group.setAttribute('applied', 'true')
                const items = Array.from(group.querySelectorAll('.boost-sd__radio-label'));
                group.setAttribute('role', 'radiogroup');

                items.forEach((item, i) => {
                    item.setAttribute('role', 'radio');
                    // item.setAttribute('aria-label', item.getAttribute('data-escape'));
                    const isSelected = item.classList.contains('boost-sd__radio-label--selected');
                    item.setAttribute('aria-checked', isSelected ? 'true' : 'false');
                    item.tabIndex = isSelected ? 0 : -1;
                });

                function selectItem(item, skipClick) {
                    items.forEach(i => {
                        i.setAttribute('aria-checked', 'false');
                        i.tabIndex = -1;
                    });

                    item.setAttribute('aria-checked', 'true');
                    item.tabIndex = 0;
                    if(!skipClick) {
                        setTimeout(() => {
                            item.focus();
                            item.click();
                        }, 100);
                    }

                }

                // --- Mouse click ---
                items.forEach(item => {
                    item.addEventListener('click', () => selectItem(item, true));
                });

                // --- Keyboard support ---
                group.addEventListener('keydown', e => {
                    const currentIndex = items.findIndex(i => i.tabIndex === 0);
                    let newIndex = currentIndex;

                    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
                        newIndex = (currentIndex + 1) % items.length;
                        e.preventDefault();
                    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
                        newIndex = (currentIndex - 1 + items.length) % items.length;
                        e.preventDefault();
                    } else if (e.key === ' ' || e.key === 'Enter') {
                        selectItem(items[currentIndex]);
                        e.preventDefault();
                        return;
                    }

                    if (newIndex !== currentIndex) {
                        selectItem(items[newIndex]);
                    }
                });
            }
            //END OF RADIO SEMANTICS

            const rating = modal.querySelector('.jdgm-prev-badge__stars');
            if(rating) {
                rating.setAttribute('aria-label', `${rating.getAttribute('data-score')} out of 5 stars`);
                rating.setAttribute('role', 'img');
                rating.removeAttribute('tabindex');
            }

            modal.querySelectorAll('.boost-sd__thumbs-container-prev-button button, .boost-sd__thumbs-container-next-button button').forEach(navBtn => {
                navBtn.setAttribute('aria-hidden', 'true');
                navBtn.setAttribute('tabindex', '-1');
            });

            const btnImgs = modal.querySelectorAll('.boost-sd__thumbs-container-thumbs-item');
            btnImgs.forEach((btn, index) => {
                btn.setAttribute('aria-label', `Product image ${index + 1} of ${btnImgs.length}`);
                btn.setAttribute('role', 'button');
                btn.setAttribute('tabindex', '0');
                btn.querySelector('img')?.setAttribute('alt', '');
                btn.setAttribute('aria-pressed', btn.classList.contains('boost-sd__thumbs-container-thumbs-item--selected').toString())
                btn.addEventListener('click', () => {
                    setTimeout(() => {
                        btnImgs.forEach(imageBtn => imageBtn.setAttribute('aria-pressed', 'false'));
                        btn.setAttribute('aria-pressed', btn.classList.contains('boost-sd__thumbs-container-thumbs-item--selected').toString())
                    }, 200);
                });
            })
            const imgs = modal.querySelectorAll('.slick-track .slick-slide:not(.slick-cloned) img');
            imgs.forEach((img, index) => {
                img.setAttribute('alt', `Product image ${index + 1} of ${imgs.length}`);
            });

            modal.querySelector('.boost-sd__modal-last-child')?.removeAttribute('tabindex');

            const price = modal.querySelector('.boost-sd__quick-view-price');
            if(price) {
                const compare = price.querySelector('.boost-sd__format-currency--price-compare');
                if(compare) {
                    const currentPrice = price.querySelector(':scope > .boost-sd__format-currency');
                    const currentPriceSpan = document.createElement('span');
                    currentPriceSpan.classList.add('visually-hidden');
                    currentPriceSpan.innerText = `Current price`;
                    const originalPriceSpan = document.createElement('span');
                    originalPriceSpan.classList.add('visually-hidden');
                    originalPriceSpan.innerText = `Original price`;

                    currentPrice.prepend(currentPriceSpan);
                    compare.prepend(originalPriceSpan);
                }
            }

            setTimeout(() => {
                trapFocus(modal, btn, undefined, false);
            }, 500);
            

            const closeBtn = modal.querySelector('.boost-sd__button-text-x');

            modal.addEventListener('keydown', (ev) => {
                if (ev.key === 'Escape') {
                    closeBtn?.click();
                }
            });
        }, 500);
        });
    }
    listenToQuickViewCollection();

    function fixDiscountPopup() {
        const discountObserver = new MutationObserver(() => {
            const modal = document.querySelector('#bndlr-discount-message');
            if(!modal) return;
            modal.setAttribute('role', 'dialog');
            modal.setAttribute('aria-modal', 'true');
            modal.setAttribute('aria-label', 'Discount Message');

            const title = modal.querySelector('.bndlr-message-title');
            if(title) {
                const h1 = document.createElement('h1');
                h1.innerText = title.innerText;
                h1.className = title.className;
                title.replaceWith(h1);
            }

            modal.querySelectorAll('.bndlr-message-yes, .bndlr-message-no, .bndlr-message-close').forEach(btn => {
                btn.setAttribute('tabindex', '0');
                btn.setAttribute('role', 'button');
                if(btn.classList.contains('bndlr-message-close')) {
                    btn.setAttribute('aria-label', 'close');
                }
            });

            trapFocus(modal);
        });

        discountObserver.observe(document.body, {
            subtree: true,
            childList: true
        });
    }

    fixDiscountPopup();

    function fixAddresses() {
        document.querySelectorAll('.sp-myaccount-content li .address').forEach(address => {
            const addressContent = address.querySelector('.content p');
            if (addressContent) {
                const items = addressContent.innerHTML
                    .split(/<br[^>]*>/)
                    .map(item => item.trim())
                    .filter(item => item.length > 0)
                    .map(item => item.replace(/<[^>]*>/g, ''));

                addressContent.innerHTML = '';
                items.forEach((element, index) => {
                    const div = document.createElement('div');
                    div.innerText = element;
                    if (index === 0) {
                        const parent = addressContent.parentNode;
                        const id = parent.getAttribute('data-id');
                        div.id = id;
                    }
                    addressContent.appendChild(div);

                });
            }
        });
    }

    fixAddresses();

    function filterPopupFix() {
        document.addEventListener('click', (event) => {
            const button = event.target.closest('.boost-sd__filter-tree-toggle-button');
            if (!button) return;

            const dialog = document.querySelector('.boost-sd__filter-tree-vertical-sticky-overlay');
            if(!dialog) return;
            setTimeout(() => {
                addModalSemantics(dialog);
            }, 300);

    })

    function addModalSemantics(modal) {
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-label', 'Filters');
        const trap = createFocusTrap(modal);
        trap.activate();
        const closeBtn = modal.querySelector('.boost-sd__button--close');
        if(closeBtn) {
            closeBtn.setAttribute('aria-label', 'Close');
            modal.addEventListener('keydown', (e) => {
                if(e.key === 'Escape') {
                    closeBtn.click();
                }
            });
        }

        modal.querySelectorAll('.boost-sd__button--back').forEach(back => {
            back.setAttribute('aria-label', 'Back');
        });

        modal.querySelectorAll('.boost-sd__filter-option-title').forEach(filter => {
            filter.setAttribute('aria-expanded', 'false');
        });

        document.addEventListener('click', e => {
            if (e.target.closest('.boost-sd__filter-option-title') || e.target.closest('.boost-sd__button--back')) {
                trap.update(); // ✅ recompute focusables
            }
        });
    }


        function createFocusTrap(container) {
            let focusable = [];
            let first = null;
            let last = null;
            let active = false;

            function update() {
                focusable = Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR))
                .filter(el => !el.hasAttribute('aria-hidden'));
                first = focusable[0] || null;
                last = focusable[focusable.length - 1] || null;
                focusable[0]?.focus();
            }

            function onKeydown(e) {
                if (!active || e.key !== 'Tab' || !first || !last) return;

                if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
                }
            }

            function activate() {
                if (active) return;
                update();
                container.addEventListener('keydown', onKeydown);
                active = true;
            }

            function deactivate() {
                if (!active) return;
                container.removeEventListener('keydown', onKeydown);
                active = false;
            }

            return {
                activate,
                deactivate,
                update
            };
        }



        const FOCUSABLE_SELECTOR = `
        a[href]:not([tabindex="-1"]):not(.screen-reader-text),
        button:not([disabled]):not([tabindex="-1"]),
        input:not([disabled]):not([type="hidden"]):not([tabindex="-1"]),
        select:not([disabled]):not([tabindex="-1"]),
        textarea:not([disabled]):not([tabindex="-1"]),
        [tabindex]:not([tabindex="-1"])
        `;
    }

    filterPopupFix();

    function fixAccessories() {
        const accessoryObs = new MutationObserver(() => {
            const container = document.querySelector('#spiceaddonsappid');
            if(!container) return


            const title = container.querySelector('.spicegems-addon-carousel-heading');

            if(!title) return;
            
            title.id = 'accessories_id'
            title.setAttribute('role', 'heading');
            title.setAttribute('aria-level', '2');

            const slider = container.querySelector('.spicegems-slides-container');
            slider.setAttribute('role', 'region');
            slider.setAttribute('aria-labelledby', title.id);

            const slideItems = slider.querySelectorAll('.spicegems-addon-slide');

            slideItems.forEach((slide, index) => {
                slide.setAttribute('role', 'group');
                slide.setAttribute('aria-label', `Slide ${index + 1} of ${slideItems.length}`);

                const imgContainer = slide.querySelector('.spicegems-addon-product-img.sg-md-img');
                if(imgContainer) {
                    imgContainer.setAttribute('aria-hidden', 'true');
                    imgContainer.querySelector('img')?.setAttribute('alt','');
                }


                const productTitle = slide.querySelector('.spicegems-addon-product-title');
                productTitle.id = `product_accessory_${index}`;
                slide.querySelectorAll('.spicegems-addon-input-felid, .spicegems-addon-btn').forEach(element => {
                    element.setAttribute('aria-describedby', productTitle.id);
                });
            });

            const prevBtn = container.querySelector('.spicegems-btn-prev');
            if(prevBtn) {
                prevBtn.setAttribute('aria-label', 'Previous');
            }

            const nextBtn = container.querySelector('.spicegems-btn-next');
            if(nextBtn) {
                nextBtn.setAttribute('aria-label', 'Next');
            }
            
            initSliderA11y(document.querySelector('.spicegems-carousel-inner'));
        });

        accessoryObs.observe(document.body, {
            subtree: true,
            childList: true
        });

        function initSliderA11y(slider) {
            const slides = slider.querySelectorAll('.spicegems-addon-slide');

            const observer = new IntersectionObserver(
                entries => {
                    entries.forEach(entry => {
                        const visible = entry.isIntersecting;
                        const slide = entry.target;

                        slide.setAttribute('aria-hidden', String(!visible));

                        slide
                        .querySelectorAll('a, button, input, select, textarea, [tabindex]')
                        .forEach(el => {
                            if (visible) {
                            el.removeAttribute('tabindex');
                            } else {
                            el.setAttribute('tabindex', '-1');
                            }
                        });
                    });
                },
                {
                root: slider,
                threshold: 0.5 // tweak based on how much must be visible
                }
            );

            slides.forEach(slide => observer.observe(slide));
            }
    }

    fixAccessories();

});